import * as core$1 from 'hel-micro-core-wujie';
import { appReady, getGlobalThis, commonUtil as commonUtil$1, log, getPlatformConfig, allowLog, helConsts as helConsts$1, getAppMeta, getVerLib, getVerApp, libReady, getVersion, setAppMeta, setVersion, getVerExtraCssList, setVerExtraCssList, getAppPlatform, setVerLoadStatus, helLoadStatus, getVerLoadStatus, getHelEventBus, helEvents, commonDataUtil, originInit } from 'hel-micro-core-wujie';
import { parseHtml } from 'hel-html-parser';

var VER$1 = '4.8.10';

/**
 * 暴露给 hel-micro 的 ui 对接层使用，例如 hel-micro-react 的 renderApp 接口，应用提供者会调用对接层开发者提供的
 * renderApp接口渲染整个应用，当应用非本地运行时，renderApp不触发渲染逻辑而是调用 emitApp 弹射整个根应用出去
 * 这样使用方可通过 react ui 对接层 的 <MicroApp name="xxApp" /> 来实例化整个远程应用
 *
 * @see https://github.com/tnfe/hel/blob/main/packages/hel-micro-react/src/process/renderApp.tsx
 */
function emitApp$1(options) {
    var appGroupName = options.appGroupName, Comp = options.Comp, platform = options.platform, lifecycle = options.lifecycle, appName = options.appName, versionId = options.versionId;
    appReady(appGroupName, Comp, { lifecycle: lifecycle, platform: platform, appName: appName, versionId: versionId });
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** api 服务模块的相关常量 */
var apiSrvConst = {
    GET_APP_AND_VER: 'getSubAppAndItsVersion',
    GET_APP_AND_FULL_VER: 'getSubAppAndItsFullVersion',
    BATCH_GET_APP_AND_VER: 'batchGetSubAppAndItsVersion',
    BATCH_GET_APP_AND_FULL_VER: 'batchGetSubAppAndItsFullVersion',
    GET_APP_VER: 'getSubAppVersion',
    GET_APP_FULL_VER: 'getSubAppFullVersion',
};
var API_NORMAL_GET = 'get';
var JSONP_MARK = 'Jsonp';

var toExport$1 = {
    LS_CACHE_APP_PREFIX: 'HelAppCache',
    // indexedDB 数据库名称
    DATABASE_NAME: 'HelIndexedDB',
    // ObjectStore 名称
    STORE_NAME: 'HelMetaData',
};

// 保存db实例
var dbContexts = {};
/**
 * 创建 dbcontext
 * @returns
 */
function createContext() {
    return {
        db: null,
        name: '',
        storeName: '',
        version: 1,
    };
}
/**
 * 获取indexedDB，若浏览器不支持则打印警告并返回 null
 * @returns
 */
function getIndexedDBFactory() {
    if (!('indexedDB' in getGlobalThis())) {
        console.warn('The current browser is not support indexedDB!');
        return null;
    }
    return getGlobalThis().indexedDB;
}
var IndexedDBStorage = /** @class */ (function () {
    function IndexedDBStorage(options) {
        this.dbInfo = createContext();
        this.ready = null;
        this.initStorage(options);
    }
    IndexedDBStorage.prototype.initStorage = function (options) {
        var indexedDB = getIndexedDBFactory();
        if (!indexedDB)
            return;
        var initResolve = null;
        var initReject = null;
        this.ready = new Promise(function (resolve, reject) {
            initResolve = resolve;
            initReject = reject;
        });
        var dbInfo = this.dbInfo;
        if (options) {
            var name = options.name, storeName = options.storeName, version = options.version;
            Object.assign(dbInfo, commonUtil$1.purify({ name: name, storeName: storeName, version: version }));
        }
        var dbContext = dbContexts[dbInfo.name];
        if (!dbContext) {
            dbContext = createContext();
            dbContexts[dbInfo.name] = dbContext;
        }
        dbInfo.db = dbContext.db;
        // 是否升级
        var isUpgrade = this.isUpgradeNeeded(dbInfo);
        if (dbInfo.db) {
            if (isUpgrade) {
                // 升级前关闭原来打开的
                dbInfo.db.close();
            }
            else {
                initResolve(dbInfo);
                return;
            }
        }
        var dbArgs = [dbInfo.name, undefined];
        if (isUpgrade) {
            dbArgs[1] = dbInfo.version;
        }
        // 打开数据库
        var openreq = indexedDB.open.apply(indexedDB, dbArgs);
        if (isUpgrade) {
            // 如果升级则监听 onupgradeneeded 事件
            openreq.onupgradeneeded = function (e) {
                dbContext.db = openreq.result;
                dbInfo.db = openreq.result;
                try {
                    // 创建 ojectStore(只能在 onupgradeneeded 事件中创建)
                    dbInfo.db.createObjectStore(dbInfo.storeName);
                }
                catch (err) {
                    // storeName 可能重复
                    if (err.name === 'ConstraintError') {
                        var tip = commonUtil$1.nbstr("\n              The database \"".concat(dbInfo.name, "\"\n              has been upgraded from version ").concat(e.oldVersion, " to version ").concat(e.newVersion, ",\n              but the storage \"").concat(dbInfo.storeName, "\" already exists."));
                        console.warn(tip);
                    }
                    else {
                        throw err;
                    }
                }
            };
        }
        openreq.onerror = function () {
            initReject(openreq.error);
        };
        openreq.onsuccess = function () {
            dbInfo.db = openreq.result;
            dbContext.db = openreq.result;
            dbInfo.db.onversionchange = function (e) {
                e.target.close();
            };
            initResolve(dbInfo);
        };
    };
    /**
     * 判断是否升级
     * @param dbInfo
     * @returns
     */
    IndexedDBStorage.prototype.isUpgradeNeeded = function (dbInfo) {
        if (!dbInfo.db)
            return true;
        // 是否有新的 objectStore
        var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
        // 是否降低版本
        var isDowngrade = dbInfo.version < dbInfo.db.version;
        // 是否升级版本
        var isUpgrade = dbInfo.version > dbInfo.db.version;
        if (isDowngrade) {
            // 对于降低版本给予提示，并继续采用之前的版本
            console.warn("The database \"".concat(dbInfo.name, "\" can't be downgraded from version ").concat(dbInfo.db.version, " to version ").concat(dbInfo.version));
            dbInfo.version = dbInfo.db.version;
        }
        if (isUpgrade || isNewStore) {
            // 有新的 objectStore 则升级版本
            if (isNewStore) {
                var incVersion = dbInfo.db.version + 1;
                if (incVersion > dbInfo.version) {
                    dbInfo.version = incVersion;
                }
            }
            return true;
        }
        return false;
    };
    IndexedDBStorage.prototype.getObjectStore = function (mode) {
        return __awaiter(this, void 0, Promise, function () {
            var dbInfo, name, db, storeName, objectStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDbInfo()];
                    case 1:
                        dbInfo = _a.sent();
                        name = dbInfo.name, db = dbInfo.db, storeName = dbInfo.storeName;
                        if (!db) {
                            throw new Error("get ".concat(storeName, " objectStore failed in ").concat(name, " database"));
                        }
                        objectStore = db.transaction(storeName, mode || 'readonly').objectStore(storeName);
                        return [2 /*return*/, objectStore];
                }
            });
        });
    };
    IndexedDBStorage.prototype.attachHandler = function (req, resolve, reject) {
        req.onsuccess = function () {
            resolve(req.result || null);
        };
        req.onerror = function () {
            reject(req.error);
        };
    };
    IndexedDBStorage.prototype.getItem = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getObjectStore()
                .then(function (objectStore) {
                var req = objectStore.get(key);
                _this.attachHandler(req, resolve, reject);
            })
                .catch(reject);
        });
    };
    IndexedDBStorage.prototype.setItem = function (key, value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getObjectStore('readwrite')
                .then(function (objectStore) {
                var req = objectStore.put(value, key);
                _this.attachHandler(req, resolve, reject);
            })
                .catch(reject);
        });
    };
    IndexedDBStorage.prototype.removeItem = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getObjectStore('readwrite')
                .then(function (objectStore) {
                var req = objectStore.delete(key);
                _this.attachHandler(req, resolve, reject);
            })
                .catch(reject);
        });
    };
    IndexedDBStorage.prototype.getDbInfo = function () {
        if (!this.ready) {
            return Promise.reject('forget init');
        }
        return this.ready;
    };
    return IndexedDBStorage;
}());

function isRelativePath(path) {
    if (path.startsWith('//'))
        return false;
    return path.startsWith('/') || path.startsWith('./') || path.startsWith('../');
}
function getAssetUrlType(webDirPath, url) {
    if (url.startsWith(webDirPath)) {
        return 'build'; // 是构建生成的 css 文件
    }
    if (isRelativePath(url)) {
        return 'relative';
    }
    return 'static';
}
function getIndexedDB() {
    if (!getIndexedDBFactory())
        return null;
    var indexedDBIns = new IndexedDBStorage({
        name: toExport$1.DATABASE_NAME,
        storeName: toExport$1.STORE_NAME,
    });
    function setItem(key, value) {
        return indexedDBIns.setItem(key, value);
    }
    function getItem(key) {
        return indexedDBIns.getItem(key);
    }
    function removeItem(key) {
        return indexedDBIns.removeItem(key);
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
    };
}
// avoid mock js-dom warn:
// [DOMException [SecurityError]: localStorage is not available for opaque origins]
function getLocalStorage() {
    var _a;
    // prettier-ignore
    var mockStorage = { getItem: function () { }, setItem: function () { }, removeItem: function () { } };
    try {
        var storage = (_a = getGlobalThis()) === null || _a === void 0 ? void 0 : _a.localStorage;
        return storage || mockStorage;
    }
    catch (err) {
        return mockStorage;
    }
}
/**
 * 支持读取 dom attrs 时只有 key 的正确含义
 * 例如通过设定 defaultValIfOnlyKey 表示 <script data-helappend /> 可拿到值为 '1' 而非 ''
 */
function getDatasetVal(dataset, key, defaultValIfOnlyKey) {
    var hasKey = Object.prototype.hasOwnProperty.call(dataset, key);
    if (hasKey) {
        return dataset[key] || defaultValIfOnlyKey;
    }
    return undefined;
}

function getUserName(options) {
    var userLsKey = options.userLsKey;
    var userName = getLocalStorage().getItem(userLsKey) || '';
    if (userName) {
        return userName;
    }
    try {
        var map_1 = {};
        getGlobalThis()
            .document.cookie.split(';')
            .forEach(function (kvStr) {
            var _a = kvStr.split('='), k = _a[0], v = _a[1];
            map_1[k] = v;
        });
        userName = map_1[userLsKey] || '';
        log('[[ getUserName ]] result:', userName);
    }
    catch (err) {
        log('[[ getUserName ]] err:', err);
    }
    return userName;
}

var builtinFns = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getUserName: getUserName
});

var isNull = commonUtil$1.isNull;
function getFn(platform, fnName, userFn) {
    var conf = getPlatformConfig(platform);
    var origin = conf.origin;
    var confFn = conf[fnName];
    // @ts-ignore
    var originFn = origin[fnName];
    return userFn || confFn || originFn;
}
function callFn(platform, fnName, params, userFn) {
    var fn = getFn(platform, fnName, userFn);
    if (fn) {
        return fn(params);
    }
    // @ts-ignore
    var builtinFn = builtinFns[fnName] || (function () { return null; });
    return builtinFn(params);
}
function getVal(platform, key, valPair, nullDef) {
    var _a = valPair || [], userVal = _a[0], defautVal = _a[1];
    if (!isNull(userVal, nullDef)) {
        return userVal;
    }
    var conf = getPlatformConfig(platform);
    var origin = conf.origin;
    // 优先返回 platInitOptions
    var confVal = conf[key];
    if (!isNull(confVal, nullDef)) {
        return confVal;
    }
    // 最后返回 originInitOptions
    // @ts-ignore
    var originVal = origin[key];
    if (!isNull(originVal, nullDef)) {
        return originVal;
    }
    return defautVal;
}
function getHookFn(loadOptions, hookKey) {
    var _a;
    var conf = getPlatformConfig(loadOptions.platform);
    var userHook = loadOptions.hook || {};
    var origin = conf.origin, hook = conf.hook;
    return userHook[hookKey] || hook[hookKey] || ((_a = origin.hook) === null || _a === void 0 ? void 0 : _a[hookKey]);
}
/**
 * 按下面 'getApiPrefix' 链接里描述的生成规则生成api域名前缀
 * @type {import('hel-micro-core-wujie').IControlPreFetchOptions['getApiPrefix']}
 * @param platform
 * @param loadOptions
 * @returns
 */
function genApiPrefix(platform, loadOptions) {
    var _a, _b, _c;
    var prefix = '';
    if (loadOptions) {
        prefix = ((_a = loadOptions.getApiPrefix) === null || _a === void 0 ? void 0 : _a.call(loadOptions)) || loadOptions.apiPrefix;
    }
    if (prefix) {
        return prefix;
    }
    var conf = getPlatformConfig(platform);
    prefix = ((_b = conf.getApiPrefix) === null || _b === void 0 ? void 0 : _b.call(conf)) || conf.apiPrefix;
    if (prefix) {
        return prefix;
    }
    var origin = conf.origin;
    prefix = ((_c = origin.getApiPrefix) === null || _c === void 0 ? void 0 : _c.call(origin)) || origin.apiPrefix;
    return prefix;
}

// @see https://www.runoob.com/jsref/prop-node-nodetype.html
var DOCUMENT_FRAGMENT_NODE = 11;
var JSONP = {
    now: function () {
        return new Date().getTime();
    },
    rand: function () {
        return Math.random().toString().substring(6);
    },
    // 删除节点元素
    removeElem: function (elem) {
        var parent = elem.parentNode;
        if (parent && parent.nodeType !== DOCUMENT_FRAGMENT_NODE) {
            parent.removeChild(elem);
        }
    },
    // url 组装 data
    parseData: function (data) {
        var ret = '';
        if (typeof data === 'string') {
            ret = data;
        }
        else if (typeof data === 'object') {
            for (var key in data) {
                ret += "".concat(ret, "&").concat(key, "=").concat(encodeURIComponent(data[key]));
            }
        }
        // 加时间戳防止缓存
        ret += "&_t=".concat(JSONP.now());
        ret = ret.substring(1);
        return ret;
    },
    getJSON: function (inputUrl, data) {
        return new Promise(function (resolve, reject) {
            var callbackName = '';
            var url = inputUrl;
            url = url + (url.indexOf('?') === -1 ? '?' : '&') + JSONP.parseData(data);
            // 检测 callback 的函数名是否已经定义
            var match = /callback=(\w+)/.exec(url);
            if (match === null || match === void 0 ? void 0 : match[1]) {
                callbackName = match[1];
            }
            else {
                callbackName = "helJsonp_".concat(JSONP.now(), "_").concat(JSONP.rand());
            }
            if (url.includes('?')) {
                url = "".concat(url, "&callback=").concat(callbackName);
            }
            else {
                url = "".concat(url, "?callback=").concat(callbackName);
            }
            var globalThis = getGlobalThis();
            var doc = globalThis.document;
            var script = doc.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.id = callbackName;
            script.onerror = reject;
            script.addEventListener('error', reject); // 早期版本的浏览器不支持 script.onerror
            // 把传进来的函数重新组装，并把它设置为全局函数，远程会触发该函数
            // @ts-ignore
            globalThis[callbackName] = function (jsonData) {
                // @ts-ignore
                delete globalThis[callbackName]; // 执行完函数就销毁
                var elem = doc.getElementById(callbackName);
                elem && JSONP.removeElem(elem);
                return resolve(jsonData);
            };
            var head = doc.getElementsByTagName('head');
            if (head === null || head === void 0 ? void 0 : head[0]) {
                head[0].appendChild(script);
            }
        });
    },
};
var getJSON = JSONP.getJSON;

function getPlatform(platform) {
    return platform || core$1.getPlatform();
}

function getXHRFactory() {
    if (!('XMLHttpRequest' in getGlobalThis())) {
        return null;
    }
    return new XMLHttpRequest();
}
function xhrFetch(url, config) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, method, xhrConfig, xhr, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = config || {}, method = _a.method, xhrConfig = __rest(_a, ["method"]);
                    xhr = new XHR(xhrConfig);
                    return [4 /*yield*/, xhr.request(url, method)];
                case 1:
                    result = _b.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
var XHR = /** @class */ (function () {
    function XHR(config) {
        this.req = null;
        this.resultPromise = Promise.resolve(null);
        this.init(config || {});
    }
    XHR.prototype.init = function (config) {
        var req = getXHRFactory();
        if (!req) {
            throw new Error('current browser is not support XMLHttpRequest!');
        }
        this.req = req;
        // 同步配置
        var responseType = config.responseType, _a = config.timeout, timeout = _a === void 0 ? 10000 : _a, withCredentials = config.withCredentials, headers = config.headers;
        req.responseType = responseType || 'json';
        req.timeout = timeout;
        req.withCredentials = !!withCredentials;
        if (headers) {
            Object.keys(headers).forEach(function (key) {
                req.setRequestHeader(key, headers[key]);
            });
        }
        var initResolve = null;
        var initReject = null;
        this.resultPromise = new Promise(function (resolve, reject) {
            initResolve = resolve;
            initReject = reject;
        });
        var wrapSuccessResult = function () {
            var response = req.response, status = req.status, statusText = req.statusText, responseURL = req.responseURL;
            initResolve({ data: response, status: status, statusText: statusText, url: responseURL });
        };
        var wrapErrResult = function (e) {
            var status = req.status, statusText = req.statusText, responseURL = req.responseURL;
            initReject({ msg: e, status: status, statusText: statusText, url: responseURL });
        };
        // 监听事件
        req.onload = function () { return wrapSuccessResult(); };
        req.onerror = function (e) { return wrapErrResult(e); };
        req.onabort = function (e) { return wrapErrResult(e); };
        req.ontimeout = function (e) { return wrapErrResult(e); };
        req.onprogress = function () { };
    };
    XHR.prototype.request = function (url, method) {
        return __awaiter(this, void 0, Promise, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.req) {
                            throw new Error('forget init');
                        }
                        // 发送请求
                        this.req.open(method ? method.toUpperCase() : 'GET', url);
                        this.req.send();
                        return [4 /*yield*/, this.resultPromise];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return XHR;
}());

function perfStart(label) {
    if (allowLog()) {
        console.time(label);
    }
}
function perfEnd(label) {
    if (allowLog()) {
        console.timeEnd(label);
    }
}
/**
 * 默认请求 unpkg
 */
function getSemverLatestVer(appName, apiPrefix) {
    return __awaiter(this, void 0, void 0, function () {
        var comment, url, _a, includeVer, ver;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    comment = 'try_detect_latest_ver';
                    return [4 /*yield*/, requestGet("".concat(apiPrefix, "/").concat(appName, "@latest/").concat(comment, "_").concat(Date.now()))];
                case 1:
                    url = (_b.sent()).url;
                    _a = url.split('@'), includeVer = _a[1];
                    ver = includeVer.split('/')[0];
                    return [2 /*return*/, ver];
            }
        });
    });
}
function requestByFetch(url, asJson) {
    return __awaiter(this, void 0, void 0, function () {
        var res, status, resUrl, json, text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getGlobalThis().fetch(url)];
                case 1:
                    res = _a.sent();
                    status = res.status, resUrl = res.url;
                    if (![200, 304].includes(status)) {
                        return [2 /*return*/, { url: resUrl, reply: null, status: status }];
                    }
                    if (!asJson) return [3 /*break*/, 3];
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    return [2 /*return*/, { url: resUrl, reply: json, status: status }];
                case 3: return [4 /*yield*/, res.text()];
                case 4:
                    text = _a.sent();
                    return [2 /*return*/, { url: resUrl, reply: text, status: status }];
            }
        });
    });
}
function requestByXHR(url, asJson) {
    return __awaiter(this, void 0, void 0, function () {
        var res, status, data, _a, resUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, xhrFetch(url, { method: 'GET', responseType: asJson ? 'json' : 'text' })];
                case 1:
                    res = _b.sent();
                    status = res.status, data = res.data, _a = res.url, resUrl = _a === void 0 ? '' : _a;
                    if (status === 400) {
                        return [2 /*return*/, { url: resUrl, reply: null, status: status }];
                    }
                    return [2 /*return*/, { url: resUrl, reply: data, status: status }];
            }
        });
    });
}
function requestGet(url, asJson) {
    if (asJson === void 0) { asJson = true; }
    return __awaiter(this, void 0, void 0, function () {
        var requester, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requester = requestByXHR;
                    // 如果支持fetch则使用
                    if (!!getGlobalThis().fetch) {
                        requester = requestByFetch;
                    }
                    return [4 /*yield*/, requester(url, asJson)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
function getAllExtraCssList(loadOptions) {
    var _a = loadOptions.extraCssList, extraCssList = _a === void 0 ? [] : _a, custom = loadOptions.custom;
    if (custom) {
        var _b = custom.extraCssList, custCssList = _b === void 0 ? [] : _b, _c = custom.enable, enable = _c === void 0 ? true : _c;
        if (enable) {
            var mergedList = commonUtil$1.merge2List(extraCssList, custCssList);
            return mergedList;
        }
    }
    return extraCssList.slice();
}

var safeParse = commonUtil$1.safeParse;
/** 内部用的工具函数 */
var inner$3 = {
    /** 处理语义化版本平台返回的结果 */
    handleSemverRet: function (ret, options) {
        var version = (ret || {}).version;
        var retVar = ret;
        if (options.onlyVersion) {
            retVar = version;
        }
        if (!options.isFullVersion && version) {
            Reflect.deleteProperty(version, 'html_content');
        }
        if (!version) {
            return { data: null, code: '404', msg: 'no version found' };
        }
        return { data: retVar, code: '0', msg: '' };
    },
    appendSearchKV: function (oriStr, key, value) {
        var newStr = oriStr;
        if (value) {
            newStr += "&".concat(key, "=").concat(value);
        }
        return newStr;
    },
    appendSuffix: function (oriStr, suffix) {
        var newStr = oriStr;
        if (suffix) {
            newStr += suffix;
        }
        return newStr;
    },
};
function executeGet(url, options) {
    return __awaiter(this, void 0, Promise, function () {
        var ret, _a, semverApi, apiMode, perfLabel, result, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ret = null;
                    _a = options.semverApi, semverApi = _a === void 0 ? true : _a;
                    apiMode = semverApi ? API_NORMAL_GET : options.apiMode;
                    perfLabel = "request ".concat(url);
                    perfStart(perfLabel);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!(apiMode === API_NORMAL_GET)) return [3 /*break*/, 3];
                    return [4 /*yield*/, requestGet(url)];
                case 2:
                    result = _b.sent();
                    ret = result.reply;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, getJSON(url)];
                case 4:
                    // jsonp get
                    ret = _b.sent();
                    _b.label = 5;
                case 5:
                    perfEnd(perfLabel);
                    // 请求语义化cdn平台时拿到的是原始数据，和自定义平台有差异
                    // 这里做一下抹平处理，以便上层可以用一致的方式读取数据
                    if (semverApi) {
                        return [2 /*return*/, inner$3.handleSemverRet(ret, options)];
                    }
                    return [2 /*return*/, ret];
                case 6:
                    err_1 = _b.sent();
                    return [2 /*return*/, { data: null, code: '404', msg: err_1.message }];
                case 7: return [2 /*return*/];
            }
        });
    });
}
function ensureApp(app) {
    var clonedApp = __assign({}, app);
    clonedApp.additional_scripts = safeParse(clonedApp.additional_scripts, []);
    clonedApp.additional_body_scripts = safeParse(clonedApp.additional_body_scripts, []);
    return clonedApp;
}
function ensureVersion(version) {
    var clonedVersion = __assign({}, version);
    clonedVersion.src_map = safeParse(clonedVersion.src_map, {
        htmlIndexSrc: '',
        webDirPath: '',
        headAssetList: [],
        bodyAssetList: [],
        chunkJsSrcList: [],
        chunkCssSrcList: [],
        staticJsSrcList: [],
        staticCssSrcList: [],
        relativeJsSrcList: [],
        relativeCssSrcList: [],
        otherSrcList: [],
    });
    return clonedVersion;
}
/**
 * 生成版本语义化的元数据请求链接
 */
function getSemverUrl(apiHost, appName, versionId, skip404Sniff) {
    if (skip404Sniff === void 0) { skip404Sniff = false; }
    return __awaiter(this, void 0, void 0, function () {
        var ver;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    ver = versionId;
                    if (!!ver) return [3 /*break*/, 3];
                    if (!skip404Sniff) return [3 /*break*/, 1];
                    ver = 'latest'; // latest 未必是最新的，unpkg 可能有延时，需用户自己抉择需不需要跳过404嗅探
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getSemverLatestVer(appName, apiHost)];
                case 2:
                    ver = _a.sent();
                    _a.label = 3;
                case 3: 
                // https://unpkg.com/hel-lodash@2.1.7/hel_dist/hel-meta.json
                // https://cdn.jsdelivr.net/npm/hel-lodash@2.1.7/hel_dist/hel-meta.json
                return [2 /*return*/, "".concat(apiHost, "/").concat(appName, "@").concat(ver, "/hel_dist/hel-meta.json?_t=").concat(Date.now())];
            }
        });
    });
}
/**
 * 生成请求的自定义平台的请求信息
 */
function prepareCustomPlatRequestInfo(appNameOrNames, getOptions) {
    var versionId = getOptions.versionId, projectId = getOptions.projectId, apiMode = getOptions.apiMode, _a = getOptions.isFullVersion, isFullVersion = _a === void 0 ? false : _a, _b = getOptions.versionIdList, versionIdList = _b === void 0 ? [] : _b, _c = getOptions.projectIdList, projectIdList = _c === void 0 ? [] : _c, _d = getOptions.loadOptions, loadOptions = _d === void 0 ? {} : _d;
    var platform = getPlatform(getOptions.platform);
    // trust me, appName will be reassign later
    var appName = appNameOrNames;
    var urlAppName = appName;
    var urlVersion = versionId;
    var urlProjId = projectId;
    var isBatch = false;
    if (Array.isArray(appNameOrNames)) {
        appName = appNameOrNames[0];
        urlAppName = appNameOrNames.join(',');
        urlVersion = versionIdList.join(',');
        urlProjId = projectIdList.join(',');
        isBatch = true;
    }
    // 按 preFetchOptions.{key} --> platInitOptions.{key} --> originInitOptions.{key} --> innerDefault 取值的函数
    var getVal$1 = function (key, defaultVal) {
        return getVal(platform, key, [loadOptions[key], defaultVal]);
    };
    var getFnVal = function (fnName, fnParams) {
        return callFn(platform, fnName, fnParams, loadOptions[fnName]);
    };
    var userLsKey = getVal$1('userLsKey', helConsts$1.DEFAULT_USER_LS_KEY);
    var userName = getFnVal('getUserName', { platform: platform, appName: appName, userLsKey: userLsKey });
    var grayResult = getFnVal('shouldUseGray', { appName: appName });
    var apiSuffix = getVal$1('apiSuffix');
    var apiPathOfApp = getVal$1('apiPathOfApp', helConsts$1.DEFAULT_API_URL);
    var apiHost = genApiPrefix(platform, loadOptions);
    var grayVar = '';
    if (typeof grayResult === 'boolean') {
        grayVar = grayResult ? '1' : '0';
    }
    // 为自定义模块管理台拼接请求链接
    var jsonpMark = apiMode === API_NORMAL_GET ? '' : JSONP_MARK;
    var interfaceName = '';
    if (!isBatch) {
        interfaceName = !isFullVersion ? apiSrvConst.GET_APP_AND_VER : apiSrvConst.GET_APP_AND_FULL_VER;
    }
    else {
        interfaceName = !isFullVersion ? apiSrvConst.BATCH_GET_APP_AND_VER : apiSrvConst.BATCH_GET_APP_AND_FULL_VER;
    }
    var finalInterfaceName = "".concat(interfaceName).concat(jsonpMark);
    var url = '';
    url = "".concat(apiHost).concat(apiPathOfApp, "/").concat(finalInterfaceName, "?name=").concat(urlAppName);
    url = inner$3.appendSearchKV(url, 'userName', userName);
    url = inner$3.appendSearchKV(url, 'version', urlVersion);
    url = inner$3.appendSearchKV(url, 'projId', urlProjId);
    url = inner$3.appendSearchKV(url, 'gray', grayVar);
    url = inner$3.appendSuffix(url, apiSuffix);
    return { url: url, userName: userName };
}
/**
 * 生成请求的 unpkg 平台的请求信息
 */
function prepareSemverRequestInfo(appName, getOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var versionId, platform, loadOptions, apiHost, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    versionId = getOptions.versionId, platform = getOptions.platform, loadOptions = getOptions.loadOptions;
                    apiHost = genApiPrefix(platform, loadOptions);
                    return [4 /*yield*/, getSemverUrl(apiHost, appName, versionId || '', loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.skip404Sniff)];
                case 1:
                    url = _a.sent();
                    return [2 /*return*/, url];
            }
        });
    });
}
/**
 * 生成请求请求信息
 */
function prepareRequestInfo(appName, getOptions) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var loadOptions, userName, url, semverApi, ret;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    loadOptions = getOptions.loadOptions;
                    userName = '';
                    url = '';
                    semverApi = (_a = loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.semverApi) !== null && _a !== void 0 ? _a : true;
                    if (!semverApi) return [3 /*break*/, 2];
                    return [4 /*yield*/, prepareSemverRequestInfo(appName, getOptions)];
                case 1:
                    url = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    ret = prepareCustomPlatRequestInfo(appName, getOptions);
                    url = ret.url;
                    userName = ret.userName;
                    _b.label = 3;
                case 3: return [2 /*return*/, { url: url, userName: userName }];
            }
        });
    });
}
/**
 * 准备请求版本数据的 url 链接
 */
function prepareRequestVersionUrl(versionId, getOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var apiMode, appName, _a, isFullVersion, _b, semverApi, platform, apiHost, apiSuffix, apiPathOfApp, apiPathOfAppVersion, url, jsonpMark, interfaceName, finalInterfaceName, finalApiPath;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    apiMode = getOptions.apiMode, appName = getOptions.appName, _a = getOptions.isFullVersion, isFullVersion = _a === void 0 ? false : _a, _b = getOptions.semverApi, semverApi = _b === void 0 ? true : _b;
                    platform = getPlatform(getOptions.platform);
                    apiHost = getVal(platform, 'apiPrefix');
                    apiSuffix = getVal(platform, 'apiSuffix');
                    apiPathOfApp = getVal(platform, 'apiPathOfApp');
                    apiPathOfAppVersion = getVal(platform, 'apiPathOfAppVersion');
                    url = '';
                    if (!semverApi) return [3 /*break*/, 2];
                    return [4 /*yield*/, getSemverUrl(apiHost, appName, versionId)];
                case 1:
                    url = _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    jsonpMark = apiMode === API_NORMAL_GET ? '' : JSONP_MARK;
                    interfaceName = !isFullVersion ? apiSrvConst.GET_APP_VER : apiSrvConst.GET_APP_FULL_VER;
                    finalInterfaceName = "".concat(interfaceName).concat(jsonpMark);
                    finalApiPath = apiPathOfAppVersion || apiPathOfApp || helConsts$1.DEFAULT_API_URL;
                    url = "".concat(apiHost).concat(finalApiPath, "/").concat(finalInterfaceName, "?ver=").concat(versionId);
                    url = inner$3.appendSearchKV(url, 'name', appName);
                    url = inner$3.appendSuffix(url, apiSuffix);
                    _c.label = 3;
                case 3: return [2 /*return*/, url];
            }
        });
    });
}
/**
 * 获取子应用和它的最新在线版本
 */
function getSubAppAndItsVersion(appName, getOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var versionId, platform, apiMode, loadOptions, getFn$1, _a, url, userName, innerRequest, fnParams, data_1, data;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    versionId = getOptions.versionId, platform = getOptions.platform, apiMode = getOptions.apiMode, loadOptions = getOptions.loadOptions;
                    getFn$1 = getFn(platform, 'getSubAppAndItsVersionFn', loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.getSubAppAndItsVersionFn);
                    return [4 /*yield*/, prepareRequestInfo(appName, getOptions)];
                case 1:
                    _a = _b.sent(), url = _a.url, userName = _a.userName;
                    innerRequest = function (custUrl, custApiMode) { return __awaiter(_this, void 0, void 0, function () {
                        var metaUrl, reply;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    metaUrl = custUrl || url;
                                    return [4 /*yield*/, executeGet(metaUrl, { apiMode: custApiMode || apiMode, semverApi: loadOptions === null || loadOptions === void 0 ? void 0 : loadOptions.semverApi })];
                                case 1:
                                    reply = _a.sent();
                                    if (0 !== parseInt(reply.code, 10) || !reply) {
                                        throw new Error((reply === null || reply === void 0 ? void 0 : reply.msg) || 'getSubAppAndItsVersion err');
                                    }
                                    return [2 /*return*/, { app: ensureApp(reply.data.app), version: ensureVersion(reply.data.version), metaUrl: metaUrl }];
                            }
                        });
                    }); };
                    if (!getFn$1) return [3 /*break*/, 3];
                    fnParams = { platform: platform, appName: appName, userName: userName, versionId: versionId, url: url, innerRequest: innerRequest };
                    return [4 /*yield*/, Promise.resolve(getFn$1(fnParams))];
                case 2:
                    data_1 = (_b.sent());
                    return [2 /*return*/, { app: ensureApp(data_1.app), version: ensureVersion(data_1.version) }];
                case 3: return [4 /*yield*/, innerRequest()];
                case 4:
                    data = _b.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
/**
 * 获取子应用版本详情
 */
function getSubAppVersion$1(versionId, options) {
    return __awaiter(this, void 0, void 0, function () {
        var apiMode, _a, isFullVersion, semverApi, url, _b, data, code, msg, versionData;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    apiMode = options.apiMode, _a = options.isFullVersion, isFullVersion = _a === void 0 ? false : _a, semverApi = options.semverApi;
                    return [4 /*yield*/, prepareRequestVersionUrl(versionId, options)];
                case 1:
                    url = _c.sent();
                    return [4 /*yield*/, executeGet(url, { apiMode: apiMode, isFullVersion: isFullVersion, semverApi: semverApi, onlyVersion: true })];
                case 2:
                    _b = _c.sent(), data = _b.data, code = _b.code, msg = _b.msg;
                    if (0 !== parseInt(code, 10) || !data) {
                        throw new Error(msg || 'ver not found');
                    }
                    versionData = ensureVersion(data);
                    return [2 /*return*/, versionData];
            }
        });
    });
}
/**
 * 批量获取子应用版本详情
 */
function batchGetSubAppAndItsVersion(appNames, batchGetOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var apiMode, batchGetFn, semverApi, platform, url, innerRequest, list, fnParams;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!appNames.length) {
                        return [2 /*return*/, []];
                    }
                    apiMode = batchGetOptions.apiMode, batchGetFn = batchGetOptions.batchGetFn, semverApi = batchGetOptions.semverApi;
                    platform = getPlatform(batchGetOptions.platform);
                    return [4 /*yield*/, prepareCustomPlatRequestInfo(appNames, batchGetOptions)];
                case 1:
                    url = (_a.sent()).url;
                    innerRequest = function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, data, code, msg, list;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, executeGet(url, { apiMode: apiMode, semverApi: semverApi })];
                                case 1:
                                    _a = _b.sent(), data = _a.data, code = _a.code, msg = _a.msg;
                                    if (0 !== parseInt(code, 10) || !data) {
                                        throw new Error(msg || 'batch get failed');
                                    }
                                    list = data.map(function (item) { return ({ app: ensureApp(item.app), version: ensureVersion(item.version) }); });
                                    return [2 /*return*/, list];
                            }
                        });
                    }); };
                    list = [];
                    if (!batchGetFn) return [3 /*break*/, 3];
                    fnParams = { url: url, platform: platform, innerRequest: innerRequest };
                    return [4 /*yield*/, Promise.resolve(batchGetFn(fnParams))];
                case 2:
                    list = (_a.sent());
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, innerRequest()];
                case 4:
                    list = _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/, list];
            }
        });
    });
}

var noop = commonUtil$1.noop, okeys = commonUtil$1.okeys;
var assign = Object.assign;
function isAssetExisted(selectors) {
    var _a;
    try {
        var doc = (_a = getGlobalThis()) === null || _a === void 0 ? void 0 : _a.document;
        var el = doc.querySelector(selectors);
        return !!el;
    }
    catch (err) {
        return false;
    }
}
/**
 * 识别 data-helappend data-helex 原语来确定资源是否能加载
 */
function canAppendByHelMark(attrs, tag) {
    var ex = attrs['data-helex'];
    var helAppend = attrs['data-helappend'];
    var g = getGlobalThis();
    if (helAppend === '0') {
        return false;
    }
    // check is ex loaded，此功能用于支持需延迟加载的 externals
    if (ex) {
        // @ts-ignore avoid error: type {xxx} was found on type 'typeof globalThis'.
        if (tag === 'script' && g[ex]) {
            // script 型的 ex，优先查 globalThis 上是否已绑定，已绑定则不能加载相同 ex 标记的资源了
            return false;
        }
        // 查 helex 特征值对应的资源是否存在
        var isExisted = isAssetExisted("".concat(tag, "[data-helex=\"").concat(ex, "\"]"));
        return !isExisted; // 不存在才加载
    }
    return true;
}
function appendEl(el, attrs, appendToBody) {
    var doc = getGlobalThis().document;
    okeys(attrs).forEach(function (key) { return el.setAttribute(key, attrs[key]); });
    if (appendToBody)
        doc.body.appendChild(el);
    else
        doc.head.appendChild(el);
}
function createScriptElement(options) {
    var attrs = options.attrs, innerText = options.innerText, _a = options.appendToBody, appendToBody = _a === void 0 ? true : _a, onloadCb = options.onloadCb;
    var src = attrs.src, rest = __rest(attrs, ["src"]);
    var restObj = rest;
    if (!src && !innerText) {
        return false;
    }
    var doc = getGlobalThis().document;
    if (src && isAssetExisted("script[src=\"".concat(src, "\"]"))) {
        return false;
    }
    if (!canAppendByHelMark(restObj, 'script')) {
        return false;
    }
    var el = doc.createElement('script');
    if (src)
        el.setAttribute('src', src);
    okeys(restObj).forEach(function (key) { return el.setAttribute(key, restObj[key]); });
    if (onloadCb)
        el.onload = onloadCb;
    if (innerText)
        el.innerText = innerText;
    appendEl(el, restObj, appendToBody);
    return true;
}
function createLinkElement(options) {
    var _a = options.appendToBody, appendToBody = _a === void 0 ? false : _a, innerText = options.innerText, attrs = options.attrs;
    var href = attrs.href, rel = attrs.rel, rest = __rest(attrs, ["href", "rel"]);
    var restObj = rest;
    var doc = getGlobalThis().document;
    if (!href && !innerText)
        return;
    if (!canAppendByHelMark(restObj, 'link')) {
        return false;
    }
    var el = doc.createElement('link');
    if (href) {
        el.setAttribute('href', href);
        el.setAttribute('rel', rel || 'stylesheet');
    }
    else if (rel) {
        // 无 href 时，不默认 rel 为 'stylesheet'
        el.setAttribute('rel', rel);
    }
    if (innerText)
        el.innerText = innerText;
    appendEl(el, restObj, appendToBody);
}
function createStyleElement(options) {
    var _a = options.appendToBody, appendToBody = _a === void 0 ? false : _a, _b = options.innerText, innerText = _b === void 0 ? '' : _b, attrs = options.attrs;
    var doc = getGlobalThis().document;
    var el = doc.createElement('style');
    el.innerText = innerText;
    appendEl(el, attrs, appendToBody);
}
// 相比 as 写法，谓词可直接将 attrs 类型缩小并适用于整个 if block 块里
function isLinkAttrs(tag, attrs) {
    noop(attrs);
    return ['link', 'staticLink', 'relativeLink'].includes(tag);
}
function isScriptAttrs(tag, attrs) {
    noop(attrs);
    return ['script', 'staticScript', 'relativeScript'].includes(tag);
}
function createDomByAssetList(assetList, options) {
    var appendToBody = options.appendToBody, appendCss = options.appendCss, webDirPath = options.webDirPath, cssAppendTypes = options.cssAppendTypes, excludeCssList = options.excludeCssList;
    assetList.forEach(function (v) {
        // 兼容历史元数据，无 append 的话就默认为 true
        var tag = v.tag, attrs = v.attrs, _a = v.append, append = _a === void 0 ? true : _a, _b = v.innerText, innerText = _b === void 0 ? '' : _b;
        if (!append) {
            return;
        }
        // 处理 link 标签
        if (isLinkAttrs(tag, attrs)) {
            var createLinkOptions = { appendToBody: appendToBody, attrs: attrs, innerText: innerText };
            var href = attrs.href;
            // .ico 文件默认不加载（ 除非显式地记录了 append 为 true ）
            if (href.endsWith('.ico') && v.append !== true) {
                return;
            }
            if (href.endsWith('.css')) {
                if (appendCss
                    && cssAppendTypes.includes(getAssetUrlType(webDirPath, href)) // 当前链接类型是合法的可以附加到 html 文档的链接类型
                    && !excludeCssList.includes(href) // 当前链接没有被设置在排除链接列表里
                ) {
                    createLinkElement(createLinkOptions);
                }
                return;
            }
            createLinkElement(createLinkOptions);
            return;
        }
        // 处理 script 标签
        if (isScriptAttrs(tag, attrs)) {
            createScriptElement({ appendToBody: appendToBody, attrs: attrs, innerText: innerText });
        }
        // 处理 style 标签
        if (tag === 'style') {
            createStyleElement({ appendToBody: appendToBody, attrs: attrs, innerText: innerText });
        }
    });
}
/**
 * 加载应用首屏的各项资源
 */
function loadAppAssets(app, version, loadOptions) {
    // 重命名，避免 @typescript-eslint/naming-convention 警告
    var _a = app.additional_scripts, additionalScripts = _a === void 0 ? [] : _a, _b = app.additional_body_scripts, additionalBodyScripts = _b === void 0 ? [] : _b;
    var _c = version.src_map, _d = _c.headAssetList, headAssetList = _d === void 0 ? [] : _d, _e = _c.bodyAssetList, bodyAssetList = _e === void 0 ? [] : _e, webDirPath = _c.webDirPath, _f = _c.chunkCssSrcList, chunkCssSrcList = _f === void 0 ? [] : _f;
    var _g = loadOptions.useAdditionalScript, useAdditionalScript = _g === void 0 ? false : _g, _h = loadOptions.appendCss, appendCss = _h === void 0 ? true : _h, _j = loadOptions.cssAppendTypes, cssAppendTypes = _j === void 0 ? ['build', 'static', 'relative'] : _j, getExcludeCssList = loadOptions.getExcludeCssList;
    var allExtraCssList = getAllExtraCssList(loadOptions);
    var allCssList = commonUtil$1.merge2List(allExtraCssList, chunkCssSrcList);
    var excludeCssList = (getExcludeCssList === null || getExcludeCssList === void 0 ? void 0 : getExcludeCssList(allCssList, { version: version })) || [];
    var createAdditionalAssets = function (scripts, appendToBody) {
        if (!scripts)
            return;
        // 严格按照顺序创建
        for (var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++) {
            var scriptUrl = scripts_1[_i];
            if (scriptUrl.endsWith('.css')) {
                if (appendCss && !excludeCssList.includes(scriptUrl)) {
                    createLinkElement({ appendToBody: appendToBody, attrs: { href: scriptUrl } });
                }
            }
            else {
                createScriptElement({ appendToBody: appendToBody, attrs: { src: scriptUrl } });
            }
        }
    };
    if (useAdditionalScript) {
        createAdditionalAssets(additionalScripts, false);
        createAdditionalAssets(additionalBodyScripts, true);
    }
    createAdditionalAssets(allExtraCssList, false);
    var optionsCommon = { excludeCssList: excludeCssList, webDirPath: webDirPath, appendCss: appendCss, cssAppendTypes: cssAppendTypes };
    // Object.assign is much faster than spread operator
    createDomByAssetList(headAssetList, assign(optionsCommon, { appendToBody: false }));
    createDomByAssetList(bodyAssetList, assign(optionsCommon, { appendToBody: true }));
}

var toExport = {
    SHADOW: true,
    SET_STYLE_AS_STRING: true,
    ENABLE_DISK_CACHE: false,
    ENABLE_SYNC_META: true,
    STORAGE_TYPE: 'localStorage',
    ENABLE_APPEND_CSS: true,
    API_MODE: 'get',
    EXTRA_DATA_PREFIX: 'HelExtraData',
};

/**
 * @returns true，匹配成功，false，匹配失败
 */
function isEmitVerMatchInputVer(appName, options) {
    var _a;
    var fnMark = '[[ isEmitVerMatchInputVer ]]';
    var platform = options.platform, emitVer = options.emitVer, inputVer = options.inputVer, projectId = options.projectId;
    var strictMatchVer = getVal(platform, 'strictMatchVer', [options.strictMatchVer]);
    var appMeta = getAppMeta(appName, platform);
    if (strictMatchVer === false) {
        log("".concat(fnMark, " set strictMatchVer false for app (").concat(appName, "), trust emitVer (").concat(emitVer, ") is the target version"));
        return true;
    }
    // 模块版本信息未发射上来的话，当做匹配成功
    if (!emitVer) {
        log("".concat(fnMark, " emitVer should not be null"));
        return true;
    }
    // 用在线版本或灰度版本比较
    if (!inputVer && appMeta) {
        var online_version = appMeta.online_version, build_version = appMeta.build_version;
        // 判断 projectId 是否传入，传入的话看 proj_ver.map[projectId].o 的值是否存在且是否和 emitVer 相等
        if (projectId) {
            var verMap = ((_a = appMeta.proj_ver) === null || _a === void 0 ? void 0 : _a.map) || {};
            var config = verMap[projectId];
            if (config) {
                // 后台是按 p1 项目灰度版本 --> p2 应用灰度版本 --> p3 项目线上版本 优先级依次降低返回的版本
                // 这里的匹配规则和后台严格对应上
                return emitVer === config.b || emitVer === build_version || emitVer === config.o;
            }
        }
        return emitVer === online_version || emitVer === build_version;
    }
    return emitVer === inputVer;
}

var DEFAULT_ONLINE_VER = helConsts$1.DEFAULT_ONLINE_VER;
var LOCAL_STR = 'http://localhost';
var LOCAL_127 = 'http://127.0.0.1';
var inner$2 = {
    isSrcMatchHost: function (src, host) {
        // 支持 custom 设定 localhost 或 127 时，能相互匹配
        if (host.startsWith(LOCAL_STR) || host.startsWith(LOCAL_127)) {
            return src.startsWith(LOCAL_STR) || src.startsWith(LOCAL_127);
        }
        return src.startsWith(host);
    },
    parseHtml: function (htmlText) {
        var isHeadOpen = true;
        var itemList = [];
        var isValidTag = function (tag) { return ['script', 'link', 'style'].includes(tag); };
        parseHtml(htmlText, {
            onTagOpen: function (tag) {
                if (isValidTag(tag)) {
                    itemList.push({ tag: tag, attrs: {}, innerText: '', head: isHeadOpen });
                }
            },
            onTagClose: function (tag, tagData) {
                if (tag === 'head')
                    isHeadOpen = false;
                if (!isValidTag(tag))
                    return;
                var lastItem = itemList[itemList.length - 1];
                if (lastItem) {
                    var firstChild = tagData.children[0] || '';
                    if (typeof firstChild === 'string') {
                        lastItem.innerText = firstChild;
                    }
                    lastItem.attrs = tagData.attrs;
                }
            },
        });
        return itemList;
    },
    convertToAssetList: function (list, host) {
        var headAssetList = [];
        var bodyAssetList = [];
        var staticCssSrcList = [];
        var staticJsSrcList = [];
        var relativeCssSrcList = [];
        var relativeJsSrcList = [];
        list.forEach(function (item) {
            var head = item.head, attrs = item.attrs, innerText = item.innerText, tag = item.tag;
            var list = head ? headAssetList : bodyAssetList;
            var src = attrs.src, href = attrs.href, helEx = attrs["data-helex"], rel = attrs.rel;
            var helAppend = getDatasetVal(attrs, 'data-helappend', '1');
            if (tag === 'style') {
                list.push({ tag: tag, attrs: attrs, innerText: innerText, append: true });
            }
            else {
                var url = src || href || '';
                var isCss = url.endsWith('.css');
                var isLink = tag === 'link';
                if (!url)
                    return;
                var append = true;
                var isBuildUrl = inner$2.isSrcMatchHost(url, host);
                // icon 资源默认不加载
                // 非构建产生的资源，如未标记 data-helappend="1" 且未标记data-helex="{exName}"，则不加载
                if (rel === 'icon' || (!isBuildUrl && helAppend !== '1' && !helEx)) {
                    append = false;
                }
                var tagVar = tag;
                if (!isBuildUrl) {
                    if (isRelativePath(url)) {
                        tagVar = isLink ? 'relativeLink' : 'relativeScript';
                        isCss ? relativeCssSrcList.push(url) : relativeJsSrcList.push(url);
                    }
                    else {
                        tagVar = isLink ? 'staticLink' : 'staticScript';
                        isCss ? staticCssSrcList.push(url) : staticJsSrcList.push(url);
                    }
                }
                var itemVar = { tag: tagVar, attrs: attrs, innerText: innerText, append: append };
                list.push(itemVar);
            }
        });
        return { headAssetList: headAssetList, bodyAssetList: bodyAssetList, staticCssSrcList: staticCssSrcList, staticJsSrcList: staticJsSrcList, relativeCssSrcList: relativeCssSrcList, relativeJsSrcList: relativeJsSrcList };
    },
    getChunkList: function (assetList) {
        var chunkCssSrcList = [];
        var chunkJsSrcList = [];
        assetList.forEach(function (asset) {
            var _a = asset.attrs, href = _a.href, src = _a.src;
            var url = href || src || '';
            if (url) {
                url.endsWith('.css') ? chunkCssSrcList.push(url) : chunkJsSrcList.push(url);
            }
        });
        return { chunkCssSrcList: chunkCssSrcList, chunkJsSrcList: chunkJsSrcList };
    },
    extactHelMeta: function (reply) {
        var code = reply.code, data = reply.data, msg = reply.msg;
        if (code && data) {
            // 符合来着管理台的相应数据特征
            if (code !== '0') {
                throw new Error(msg || 'server error occurred');
            }
            return data;
        }
        // 当作是来自 cdn 存储的元数据
        return reply;
    },
    getHelMeta: function (appName, apiUrl, throwError) {
        return __awaiter(this, void 0, void 0, function () {
            var msg, reply, helMeta, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msg = function (detail) {
                            if (detail === void 0) { detail = ''; }
                            return "fetch ".concat(appName, " helmeta by url ").concat(apiUrl, " failed in custom mode! ").concat(detail);
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, requestGet(apiUrl)];
                    case 2:
                        reply = (_a.sent()).reply;
                        helMeta = inner$2.extactHelMeta(reply);
                        if (helMeta && helMeta.app && helMeta.version) {
                            helMeta.app.__fromCust = true;
                            return [2 /*return*/, helMeta];
                        }
                        if (throwError) {
                            throw new Error(msg());
                        }
                        log('[[ getCustomMeta ]] 404 is a expected behavior for custom mode, user can ignore it');
                        return [2 /*return*/, null];
                    case 3:
                        err_1 = _a.sent();
                        if (throwError) {
                            throw new Error(msg(err_1.messgae));
                        }
                        commonUtil$1.noop('json parse fail or other error');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
};
function isCustomValid(custom) {
    if (custom) {
        var _a = custom.enable, enable = _a === void 0 ? true : _a, host = custom.host;
        return !!(host && enable);
    }
    return false;
}
function getCustomMeta(appName, custom) {
    return __awaiter(this, void 0, Promise, function () {
        var host, appGroupName, _a, skipFetchHelMeta, isApiUrl, parseHtml, t, helMeta, helMetaUrl, helMeta, htmlText, result, err_2, parseFn, nodeList, _b, headAssetList, bodyAssetList, restList, srcList;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    host = custom.host, appGroupName = custom.appGroupName, _a = custom.skipFetchHelMeta, skipFetchHelMeta = _a === void 0 ? false : _a, isApiUrl = custom.isApiUrl, parseHtml = custom.parseHtml;
                    t = Date.now();
                    if (!isApiUrl) return [3 /*break*/, 2];
                    return [4 /*yield*/, inner$2.getHelMeta(appName, host, true)];
                case 1:
                    helMeta = _c.sent();
                    return [2 /*return*/, helMeta];
                case 2:
                    if (!!skipFetchHelMeta) return [3 /*break*/, 4];
                    helMetaUrl = host.endsWith('hel-meta.json') ? host : "".concat(host, "/hel-meta.json?_t=").concat(t);
                    return [4 /*yield*/, inner$2.getHelMeta(appName, helMetaUrl)];
                case 3:
                    helMeta = _c.sent();
                    if (helMeta) {
                        return [2 /*return*/, helMeta];
                    }
                    _c.label = 4;
                case 4:
                    htmlText = '';
                    _c.label = 5;
                case 5:
                    _c.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, requestGet("".concat(host, "/index.html?_t=").concat(t), false)];
                case 6:
                    result = _c.sent();
                    htmlText = result.reply || '';
                    if (![200, 304].includes(result.status)) {
                        throw new Error("status ".concat(result.status));
                    }
                    return [3 /*break*/, 8];
                case 7:
                    err_2 = _c.sent();
                    throw new Error("".concat(err_2.message, " from ").concat(host));
                case 8:
                    parseFn = parseHtml || inner$2.parseHtml;
                    nodeList = parseFn(htmlText);
                    _b = inner$2.convertToAssetList(nodeList, host), headAssetList = _b.headAssetList, bodyAssetList = _b.bodyAssetList, restList = __rest(_b, ["headAssetList", "bodyAssetList"]);
                    srcList = inner$2.getChunkList(headAssetList.concat(bodyAssetList));
                    return [2 /*return*/, {
                            app: {
                                // @ts-ignore，标记来自 cust 配置
                                __fromCust: true,
                                name: appName,
                                app_group_name: appGroupName || appName,
                                online_version: DEFAULT_ONLINE_VER,
                                build_version: DEFAULT_ONLINE_VER,
                            },
                            version: {
                                sub_app_name: appName,
                                sub_app_version: DEFAULT_ONLINE_VER,
                                src_map: __assign(__assign({ webDirPath: host, headAssetList: headAssetList, bodyAssetList: bodyAssetList }, srcList), restList),
                            },
                        }];
            }
        });
    });
}

var commonUtil = core$1.commonUtil, helConsts = core$1.helConsts;
var KEY_ASSET_CTX = helConsts.KEY_ASSET_CTX;
var inner$1 = {
    recordAssetCtx: function (appInfo, appVersion, options) {
        var name = appInfo.name, app_group_name = appInfo.app_group_name;
        var srcMap = appVersion.src_map, ver = appVersion.sub_app_version;
        var _a = srcMap.chunkCssSrcList, chunkCssSrcList = _a === void 0 ? [] : _a, _b = srcMap.chunkJsSrcList, chunkJsSrcList = _b === void 0 ? [] : _b;
        var fn = getHookFn(options, 'beforeAppendAssetNode');
        var assetList = chunkCssSrcList.concat(chunkJsSrcList);
        var platform = options.platform;
        // 记录资源映射的 配置上下文数据，方便以下作用
        // 1 记录 beforeAppendAssetNode 句柄引用，方便 patchAppendChild 逻辑里做追加的资源替换
        // 2 记录资源不能加载情况，方便 patchAppendChild 逻辑里，不追加资源到 document，用于拦截 webpack 异步加载的资源（目前只对css有效）
        assetList.forEach(function (url) {
            var urlData = core$1.getCommonData(KEY_ASSET_CTX, url) || {};
            if (!urlData.marked) {
                Object.assign(urlData, {
                    marked: true,
                    platform: platform,
                    groupName: app_group_name,
                    name: name,
                    ver: ver,
                    beforeAppend: fn,
                });
                core$1.setCommonData(KEY_ASSET_CTX, url, urlData);
            }
        });
    },
    tryTriggerOnFetchMetaSuccess: function (appInfo, appVersion, options) {
        var loadOptions = options.loadOptions, fromFallback = options.fromFallback;
        var fn = getHookFn(loadOptions, 'onFetchMetaSuccess');
        fn === null || fn === void 0 ? void 0 : fn({ app: appInfo, version: appVersion, fromFallback: fromFallback });
    },
};
function getFallbackHook(options) {
    var legacyFn = getFn(options.platform, 'onFetchMetaFailed', options.onFetchMetaFailed);
    var newFn = getHookFn(options, 'onFetchMetaFailed');
    return newFn || legacyFn;
}
/**
 * 如果用户未指定 apiMode，或许将来node 环境则一定是 get
 */
function computeApiMode(platform, specifiedApiMode) {
    var apiMode = core$1.getPlatformConfig(platform).apiMode;
    if (specifiedApiMode) {
        return specifiedApiMode;
    }
    return apiMode;
}
function getPlatformAndApiMode(specifiedPlatform, specifiedApiMode) {
    var platform = getPlatform(specifiedPlatform);
    var apiMode = computeApiMode(platform, specifiedApiMode);
    return { platform: platform, apiMode: apiMode };
}
function getAppCacheKey(appName) {
    return "".concat(toExport$1.LS_CACHE_APP_PREFIX, ".").concat(appName);
}
function getDiskCachedApp(appName, options) {
    return __awaiter(this, void 0, Promise, function () {
        var indexedDBStorage, appCache, appCacheStr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(options.storageType === 'indexedDB')) return [3 /*break*/, 2];
                    indexedDBStorage = getIndexedDB();
                    if (!indexedDBStorage) return [3 /*break*/, 2];
                    return [4 /*yield*/, indexedDBStorage.getItem(getAppCacheKey(appName))];
                case 1:
                    appCache = _a.sent();
                    return [2 /*return*/, appCache];
                case 2:
                    appCacheStr = getLocalStorage().getItem(getAppCacheKey(appName));
                    return [2 /*return*/, commonUtil.safeParse(appCacheStr || '', null)];
            }
        });
    });
}
function clearDiskCachedApp$1(appName) {
    return __awaiter(this, void 0, void 0, function () {
        var indexedDBStorage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    indexedDBStorage = getIndexedDB();
                    if (!indexedDBStorage) return [3 /*break*/, 2];
                    return [4 /*yield*/, indexedDBStorage.removeItem(getAppCacheKey(appName))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    getLocalStorage().removeItem(getAppCacheKey(appName));
                    return [2 /*return*/];
            }
        });
    });
}
function getAppFromRemoteOrLocal(appName, options, fnOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, enableDiskCache, _b, enableSyncMeta, _c, versionId, _d, projectId, _e, isFullVersion, custom, strictMatchVer, semverApi, _f, callRemote, _g, platform, apiMode, _h, app, version, memApp, memAppVersion, srcInnerOptions, mayCachedApp, tryGetFromRemote, appInfo, appVersion;
        var _this = this;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _a = options.enableDiskCache, enableDiskCache = _a === void 0 ? toExport.ENABLE_DISK_CACHE : _a, _b = options.enableSyncMeta, enableSyncMeta = _b === void 0 ? toExport.ENABLE_SYNC_META : _b, _c = options.versionId, versionId = _c === void 0 ? '' : _c, _d = options.projectId, projectId = _d === void 0 ? '' : _d, _e = options.isFullVersion, isFullVersion = _e === void 0 ? false : _e, custom = options.custom, strictMatchVer = options.strictMatchVer, semverApi = options.semverApi;
                    _f = (fnOptions || {}).callRemote, callRemote = _f === void 0 ? true : _f;
                    _g = getPlatformAndApiMode(options.platform, options.apiMode), platform = _g.platform, apiMode = _g.apiMode;
                    if (!isCustomValid(custom)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCustomMeta(appName, custom)];
                case 1:
                    _h = _j.sent(), app = _h.app, version = _h.version;
                    cacheApp(app, { appVersion: version, platform: platform, toDisk: false, loadOptions: options });
                    core$1.setAppPlatform(app.app_group_name, platform);
                    return [2 /*return*/, { appInfo: app, appVersion: version }];
                case 2:
                    memApp = core$1.getAppMeta(appName, platform);
                    memAppVersion = core$1.getVersion(appName, { platform: platform, versionId: versionId });
                    // 优先从内存获取（非语义化api获取的 memAppVersion 才是有意义的，可进入此逻辑做判断）
                    // TODO : semverApi 下沉到 isEmitVerMatchInputVer 里面
                    if (!semverApi
                        && memApp
                        && memAppVersion
                        && isEmitVerMatchInputVer(appName, { platform: platform, projectId: projectId, emitVer: memAppVersion.sub_app_version, inputVer: versionId, strictMatchVer: strictMatchVer })) {
                        return [2 /*return*/, { appInfo: memApp, appVersion: memAppVersion }];
                    }
                    srcInnerOptions = { platform: platform, apiMode: apiMode, versionId: versionId, projectId: projectId, isFullVersion: isFullVersion, loadOptions: options };
                    mayCachedApp = null;
                    tryGetFromRemote = function (allowGet) { return __awaiter(_this, void 0, void 0, function () {
                        var remoteApp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!allowGet) return [3 /*break*/, 2];
                                    return [4 /*yield*/, getAndCacheApp(appName, srcInnerOptions)];
                                case 1:
                                    remoteApp = _a.sent();
                                    return [2 /*return*/, remoteApp];
                                case 2: return [2 /*return*/, null];
                            }
                        });
                    }); };
                    if (!enableDiskCache) return [3 /*break*/, 9];
                    return [4 /*yield*/, getDiskCachedApp(appName, options)];
                case 3:
                    mayCachedApp = _j.sent();
                    if (!!mayCachedApp) return [3 /*break*/, 5];
                    return [4 /*yield*/, tryGetFromRemote(callRemote)];
                case 4:
                    mayCachedApp = _j.sent();
                    return [3 /*break*/, 8];
                case 5:
                    appInfo = mayCachedApp.appInfo, appVersion = mayCachedApp.appVersion;
                    if (!(versionId && appVersion.sub_app_version !== versionId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, tryGetFromRemote(callRemote)];
                case 6:
                    mayCachedApp = _j.sent();
                    return [3 /*break*/, 8];
                case 7:
                    // 将硬盘缓存数据写回到内存
                    cacheApp(appInfo, { appVersion: appVersion, platform: platform, toDisk: false, loadOptions: options });
                    // 异步缓存一份最新的数据
                    tryGetFromRemote(enableSyncMeta).catch(function (err) { return commonUtil.noop(err); });
                    _j.label = 8;
                case 8: return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, tryGetFromRemote(callRemote)];
                case 10:
                    mayCachedApp = _j.sent();
                    _j.label = 11;
                case 11:
                    // 此处记录【应用组名】对应【平台】，仅为了让模块暴露方在使用 exposeLib 接口或 libReady 接口如未显式的指定平台值，
                    // 但 preFetch 指定了平台值去拉取模块时，能够自动帮 exposeLib、libReady 推导出模块对应的平台值
                    // 但是依然强烈建议给 exposeLib 、libReady 显式指定平台值，避免用户通过 preFetchLib 引入了多平台的同名包体时
                    // 出现推导错误的情况出现
                    if (mayCachedApp) {
                        core$1.setAppPlatform(mayCachedApp.appInfo.app_group_name, platform);
                    }
                    return [2 /*return*/, mayCachedApp];
            }
        });
    });
}
function getAppWithFallback(appName, options) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, isFirstCall, data, err_1, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = options.isFirstCall, isFirstCall = _a === void 0 ? true : _a;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, getAppFromRemoteOrLocal(appName, options)];
                case 2:
                    data = _b.sent();
                    return [2 /*return*/, { data: data, err: '' }];
                case 3:
                    err_1 = _b.sent();
                    // 第一次调用出错，抛上去，让上层再尝试一次
                    if (isFirstCall) {
                        throw err_1;
                    }
                    // 有指定 fallbackHook，返回空结果，让上层触发兜底函数
                    if (getFallbackHook(options)) {
                        return [2 /*return*/, { data: null, err: err_1.message }];
                    }
                    return [4 /*yield*/, getDiskCachedApp(appName, options)];
                case 4:
                    data = _b.sent();
                    if (!data) {
                        throw err_1;
                    }
                    commonUtil.nbalert("\n      ".concat(err_1.message, ", hel-micro will try use cached data to keep your app works well,\n      please check your network if this behavior is not as you expected!\n    "));
                    return [2 /*return*/, { data: data, err: '' }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getAppAndVersion(appName, options) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, platform, apiMode, fixedOptions, _b, appInfo, appVersion;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = getPlatformAndApiMode(options.platform, options.apiMode), platform = _a.platform, apiMode = _a.apiMode;
                    fixedOptions = __assign(__assign({}, options), { platform: platform, apiMode: apiMode });
                    return [4 /*yield*/, getSubAppAndItsVersion(appName, fixedOptions)];
                case 1:
                    _b = _c.sent(), appInfo = _b.app, appVersion = _b.version;
                    if (!appVersion) {
                        throw new Error('no version found or builded');
                    }
                    return [2 /*return*/, { appInfo: appInfo, appVersion: appVersion }];
            }
        });
    });
}
function cacheApp(appInfo, options) {
    // toDisk 默认是 true
    var appVersion = options.appVersion, platform = options.platform, _a = options.toDisk, toDisk = _a === void 0 ? true : _a, loadOptions = options.loadOptions;
    if (!appInfo || !appVersion) {
        return;
    }
    var appMeta = appInfo;
    var appName = appMeta.name;
    // 写 disk
    if (toDisk) {
        var saveToLocalStorage_1 = function () {
            try {
                getLocalStorage().setItem(getAppCacheKey(appName), JSON.stringify({ appInfo: appInfo, appVersion: appVersion }));
            }
            catch (err) {
                core$1.log('save localStorage failed');
            }
        };
        if (loadOptions.storageType === 'indexedDB') {
            var indexedDBStorage = getIndexedDB();
            if (indexedDBStorage) {
                indexedDBStorage.setItem(getAppCacheKey(appName), { appInfo: appInfo, appVersion: appVersion }).catch(function (err) {
                    core$1.log("save indexeddb failed, use localStorage instead, err: ".concat(err.message));
                    saveToLocalStorage_1();
                });
            }
            else {
                saveToLocalStorage_1();
            }
        }
        else {
            saveToLocalStorage_1();
        }
    }
    // 写 mem app
    if (loadOptions.semverApi) {
        var meta = core$1.getAppMeta(appName, platform);
        // @ts-ignore, inject __setByLatest
        if ((meta === null || meta === void 0 ? void 0 : meta.__setByLatest) !== true) {
            // @ts-ignore, inject __setByLatest，确保未设置版本好的调用写入 appMeta 后，后续其他版本的调用不在写入新的 appMeta
            appMeta = !loadOptions.versionId ? __assign(__assign({}, appMeta), { __setByLatest: true }) : appMeta;
            core$1.setAppMeta(appMeta, platform);
        }
    }
    else {
        core$1.setAppMeta(appInfo, platform);
    }
    // 写 mem version
    core$1.setVersion(appName, appVersion, { platform: platform });
    // 记录sdk注入的额外样式
    var cssList = getAllExtraCssList(loadOptions);
    core$1.setVerExtraCssList(appName, cssList, { platform: platform, versionId: appVersion.sub_app_version });
}
function getAndCacheApp(appName, options) {
    return __awaiter(this, void 0, void 0, function () {
        var platform, loadOptions, ret, appInfo, appVersion;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    platform = options.platform, loadOptions = options.loadOptions;
                    return [4 /*yield*/, getAppAndVersion(appName, options)];
                case 1:
                    ret = _a.sent();
                    appInfo = ret.appInfo, appVersion = ret.appVersion;
                    cacheApp(appInfo, { appVersion: appVersion, platform: platform, loadOptions: loadOptions });
                    return [2 /*return*/, ret];
            }
        });
    });
}
/**
 * 加载应用的入口函数，先获取元数据，再加载资源
 */
function loadApp(appName, loadOptions) {
    if (loadOptions === void 0) { loadOptions = {}; }
    return __awaiter(this, void 0, Promise, function () {
        var _a, isFirstCall, _b, controlLoadAssets, platform, _c, versionId, _d, data, err, _e, appInfo_1, appVersion_1, noMeta, fromFallback, fallbackHook, meta, startLoad, err_2, ret;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _a = loadOptions.isFirstCall, isFirstCall = _a === void 0 ? true : _a, _b = loadOptions.controlLoadAssets, controlLoadAssets = _b === void 0 ? false : _b, platform = loadOptions.platform, _c = loadOptions.versionId, versionId = _c === void 0 ? '' : _c;
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 5, , 8]);
                    return [4 /*yield*/, getAppWithFallback(appName, loadOptions)];
                case 2:
                    _d = _f.sent(), data = _d.data, err = _d.err;
                    _e = data || {}, appInfo_1 = _e.appInfo, appVersion_1 = _e.appVersion;
                    noMeta = !appInfo_1 || !appVersion_1;
                    fromFallback = false;
                    if (!(noMeta && !isFirstCall)) return [3 /*break*/, 4];
                    fallbackHook = getFallbackHook(loadOptions);
                    if (!fallbackHook) return [3 /*break*/, 4];
                    return [4 /*yield*/, Promise.resolve(fallbackHook({ platform: platform, appName: appName, versionId: versionId }))];
                case 3:
                    meta = _f.sent();
                    if (meta) {
                        appInfo_1 = meta.app;
                        appVersion_1 = meta.version;
                        fromFallback = true;
                        cacheApp(appInfo_1, { appVersion: appVersion_1, platform: getPlatform(platform), toDisk: false, loadOptions: loadOptions });
                    }
                    _f.label = 4;
                case 4:
                    if (!appInfo_1) {
                        throw new Error(err || "app[".concat(appName, "] not exist"));
                    }
                    if (!appVersion_1) {
                        throw new Error(err || "app[".concat(appName, "]'s version[").concat(versionId, "] not exist"));
                    }
                    inner$1.tryTriggerOnFetchMetaSuccess(appInfo_1, appVersion_1, { loadOptions: loadOptions, fromFallback: fromFallback });
                    inner$1.recordAssetCtx(appInfo_1, appVersion_1, loadOptions);
                    startLoad = function () {
                        loadAppAssets(appInfo_1, appVersion_1, loadOptions);
                    };
                    // !!! 需要人工控制开始加载资源的时机
                    if (controlLoadAssets) {
                        return [2 /*return*/, startLoad];
                    }
                    startLoad();
                    return [2 /*return*/, null];
                case 5:
                    err_2 = _f.sent();
                    if (!isFirstCall) return [3 /*break*/, 7];
                    console.error('loadApp err and try one more time: ', err_2);
                    return [4 /*yield*/, loadApp(appName, __assign(__assign({}, loadOptions), { isFirstCall: false }))];
                case 6:
                    ret = _f.sent();
                    return [2 /*return*/, ret];
                case 7: throw new Error("loadApp [".concat(appName, "] err (").concat(err_2.message, "), recommend config onFetchMetaFailed hook"));
                case 8: return [2 /*return*/];
            }
        });
    });
}

/**
 * 获取应用构建版本数据
 */
function getSubAppVersion(versionId, options) {
    return __awaiter(this, void 0, Promise, function () {
        var versionData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSubAppVersion$1(versionId, options)];
                case 1:
                    versionData = _a.sent();
                    return [2 /*return*/, versionData];
            }
        });
    });
}
/**
 * 获取应用自身描述和构建版本数据
 */
function getSubAppMeta(appName, options) {
    return __awaiter(this, void 0, Promise, function () {
        var meta;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSubAppAndItsVersion(appName, options || {})];
                case 1:
                    meta = _a.sent();
                    return [2 /*return*/, meta];
            }
        });
    });
}
/**
 * 获取某个应用的元数据请求链接
 * @param appName 应用名称
 * @param options
 * @returns
 */
function getMetaDataUrl(appName, options) {
    var _a = options || {}, versionId = _a.versionId, platform = _a.platform, _b = _a.apiMode, apiMode = _b === void 0 ? API_NORMAL_GET : _b, _c = _a.protocol, protocol = _c === void 0 ? 'http' : _c, projectId = _a.projectId, _d = _a.semverApi, semverApi = _d === void 0 ? true : _d;
    var url = prepareCustomPlatRequestInfo(appName, { platform: platform, versionId: versionId, apiMode: apiMode, projectId: projectId, semverApi: semverApi }).url;
    if (protocol === 'http') {
        url = url.replace('https:', 'http:');
    }
    return url;
}
function clearDiskCachedApp(appNameOrNames) {
    return __awaiter(this, void 0, void 0, function () {
        var tasks_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!Array.isArray(appNameOrNames)) return [3 /*break*/, 2];
                    tasks_1 = [];
                    appNameOrNames.forEach(function (name) { return tasks_1.push(clearDiskCachedApp$1(name)); });
                    return [4 /*yield*/, Promise.all(tasks_1)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, clearDiskCachedApp$1(appNameOrNames)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}

var appMeta = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getSubAppVersion: getSubAppVersion,
  getSubAppMeta: getSubAppMeta,
  getMetaDataUrl: getMetaDataUrl,
  clearDiskCachedApp: clearDiskCachedApp
});

/**
 * 参数相关服务
 */
function getWebDirPath$1(name, options) {
    var verData = core$1.getVersion(name, options);
    return (verData === null || verData === void 0 ? void 0 : verData.src_map.webDirPath) || '';
}

/**
 * 参数相关服务
 */
/**
 * 推导当前应用的平台与版本
 * 调用者需自己确保版本数据已获取，即 preFetchApp 或 preFetchLib 已调用结束
 */
function getPlatAndVer(appName, options) {
    var optionsVar = options || {};
    var platform = getPlatform(optionsVar.platform);
    var versionId = optionsVar.versionId || '';
    if (!versionId) {
        var versionData = core$1.getVersion(appName, { platform: platform });
        if (versionData) {
            // 已存在了正在运行的版本数据
            versionId = versionData.sub_app_version;
        }
        else {
            var appMeta = core$1.getAppMeta(appName, platform);
            versionId = (appMeta === null || appMeta === void 0 ? void 0 : appMeta.online_version) || (appMeta === null || appMeta === void 0 ? void 0 : appMeta.build_version) || '';
        }
    }
    return {
        platform: platform,
        versionId: versionId,
    };
}
function getGroupedStyleList(appName, options) {
    var map = {
        static: [],
        build: [],
    };
    var version = core$1.getVersion(appName, options);
    if (version) {
        var _a = version.src_map, webDirPath_1 = _a.webDirPath, chunkCssSrcList = _a.chunkCssSrcList;
        chunkCssSrcList.forEach(function (src) {
            src.startsWith(webDirPath_1) ? map.build.push(src) : map.static.push(src);
        });
    }
    return map;
}
var getWebDirPath = getWebDirPath$1;

var appParam = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPlatAndVer: getPlatAndVer,
  getGroupedStyleList: getGroupedStyleList,
  getWebDirPath: getWebDirPath
});

var KEY_CSS_STR = core$1.helConsts.KEY_CSS_STR;
var _a = core$1.helLoadStatus, LOADED = _a.LOADED, LOADING = _a.LOADING, NOT_LOAD = _a.NOT_LOAD;
var merge2List = core$1.commonUtil.merge2List;
var eventBus$2 = core$1.getHelEventBus();
var STYLE_STR_FETCHED = core$1.helEvents.STYLE_STR_FETCHED;
var inner = {
    isStyleStatusMatch: function (appName, judeStatus, options) {
        var _a = getPlatAndVer(appName, options), platform = _a.platform, versionId = _a.versionId;
        var status = core$1.getVerStyleStrStatus(appName, { platform: platform, versionId: versionId });
        return status === judeStatus;
    },
    /**
     * 获取应用自身的样式列表，返回如下
     * buildCssList ：应用构建生成的
     * initExtraCssList ：preFetch 是设定的，该列表只接收一次设置，后续不再变动
     * appCssList ：应用构建生成的与能追加的 staticLink、relativeLink 全部样式列表
     */
    getSelfCssList: function (appName, options) {
        var platAndVer = getPlatAndVer(appName, options);
        var appVersion = core$1.getVersion(appName, platAndVer);
        // 获取用户 preFetch 时设定的额外样式列表
        var initExtraCssList = core$1.getVerExtraCssList(appName, platAndVer);
        // 获取构建阶段生成的样式列表
        var buildCssList = [];
        // 应用自身的所有样式列表，包含构建的 staticLink、relativeLink 里可以追加的，preFetch 是设定的 extraCssList
        var appCssList = [];
        if (appVersion) {
            var _a = appVersion.src_map || {}, _b = _a.chunkCssSrcList, chunkCssSrcList = _b === void 0 ? [] : _b, _c = _a.headAssetList, headAssetList = _c === void 0 ? [] : _c, _d = _a.bodyAssetList, bodyAssetList = _d === void 0 ? [] : _d;
            buildCssList = chunkCssSrcList;
            var filterCssList = function (assetList) {
                var resultList = [];
                assetList.forEach(function (assetItem) {
                    var _a = assetItem.append, append = _a === void 0 ? true : _a; // 默认 true，兼容旧数据
                    var href = assetItem.attrs.href || '';
                    if (href.endsWith('.css') && append) {
                        resultList.push(href);
                    }
                });
                return resultList;
            };
            var htmlCssList = merge2List(filterCssList(headAssetList), filterCssList(bodyAssetList));
            appCssList = merge2List(htmlCssList, buildCssList);
        }
        appCssList = merge2List(appCssList, initExtraCssList);
        return { buildCssList: buildCssList, initExtraCssList: initExtraCssList, appCssList: appCssList };
    },
    fetchStyleStr: function (cssList) {
        return __awaiter(this, void 0, void 0, function () {
            var str, i, len, cssUrl, cachedCssStr, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = '';
                        i = 0, len = cssList.length;
                        _a.label = 1;
                    case 1:
                        if (!(i < len)) return [3 /*break*/, 7];
                        cssUrl = cssList[i];
                        if (!cssUrl.endsWith('.css')) {
                            return [3 /*break*/, 6];
                        }
                        cachedCssStr = core$1.getCommonData(KEY_CSS_STR, cssUrl);
                        if (!!cachedCssStr) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, requestGet(cssUrl, false)];
                    case 3:
                        result = _a.sent();
                        cachedCssStr = result.reply;
                        core$1.setCommonData(KEY_CSS_STR, cssUrl, cachedCssStr);
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        str += cachedCssStr;
                        _a.label = 6;
                    case 6:
                        i++;
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/, str];
                }
            });
        });
    },
    waitStyleReady: function (appName, options) {
        return __awaiter(this, void 0, void 0, function () {
            var handleStyleFetched;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handleStyleFetched = null;
                        return [4 /*yield*/, new Promise(function (resolve) {
                                handleStyleFetched = function (styleInfo) {
                                    var emitAppName = styleInfo.appName, emitPlatform = styleInfo.platform, emitVer = styleInfo.versionId;
                                    var inputVer = options.versionId, platform = options.platform, strictMatchVer = options.strictMatchVer;
                                    if (emitAppName !== appName
                                        || emitPlatform !== platform
                                        || !isEmitVerMatchInputVer(appName, { platform: platform, emitVer: emitVer, inputVer: inputVer, strictMatchVer: strictMatchVer })) {
                                        return;
                                    }
                                    resolve(true);
                                };
                                // 先监听，再触发资源加载，确保监听不会有遗漏
                                eventBus$2.on(STYLE_STR_FETCHED, handleStyleFetched);
                            })];
                    case 1:
                        _a.sent();
                        if (handleStyleFetched) {
                            eventBus$2.off(STYLE_STR_FETCHED, handleStyleFetched);
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    computeStyleData: function (appName, options) {
        var platAndVer = getPlatAndVer(appName, options);
        var _a = inner.getSelfCssList(appName, options), appCssList = _a.appCssList, buildCssList = _a.buildCssList, initExtraCssList = _a.initExtraCssList;
        var _b = options.extraCssList, extraCssList = _b === void 0 ? [] : _b, getExcludeCssList = options.getExcludeCssList; // extraCssList 此时表示二次透传的
        var allCssList = merge2List(appCssList, extraCssList);
        var excludeCssList = (getExcludeCssList === null || getExcludeCssList === void 0 ? void 0 : getExcludeCssList(allCssList, { version: core$1.getVersion(appName, platAndVer) })) || [];
        // 仅使用应用自身的样式列表
        var onlyUseAppCssList = !excludeCssList.length && !extraCssList.length;
        var validCssList = allCssList;
        if (excludeCssList.length) {
            // 按照 excludeCssList 配置过滤 allCssList ，才是最终得到的合法样式列表
            validCssList = allCssList.filter(function (item) { return !excludeCssList.includes(item); });
        }
        return { validCssList: validCssList, onlyUseAppCssList: onlyUseAppCssList, buildCssList: buildCssList, initExtraCssList: initExtraCssList, appCssList: appCssList };
    },
    fetchStyleData: function (appName, options) {
        return __awaiter(this, void 0, void 0, function () {
            var platAndVer, _a, extraStyleStr, cssListToStr, _b, extraCssList, _c, validCssList, onlyUseAppCssList, buildCssList, initExtraCssList, appCssList, result, status, appStyleStr, styleStr;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        platAndVer = getPlatAndVer(appName, options);
                        _a = options.extraStyleStr, extraStyleStr = _a === void 0 ? '' : _a, cssListToStr = options.cssListToStr, _b = options.extraCssList, extraCssList = _b === void 0 ? [] : _b;
                        _c = inner.computeStyleData(appName, options), validCssList = _c.validCssList, onlyUseAppCssList = _c.onlyUseAppCssList, buildCssList = _c.buildCssList, initExtraCssList = _c.initExtraCssList, appCssList = _c.appCssList;
                        result = {
                            validCssList: validCssList,
                            buildCssList: buildCssList,
                            initExtraCssList: initExtraCssList,
                            appCssList: appCssList,
                            extraCssList: extraCssList,
                            extraStyleStr: extraStyleStr,
                            renderStyleStr: '',
                        };
                        if (!cssListToStr) {
                            return [2 /*return*/, result];
                        }
                        if (!onlyUseAppCssList) return [3 /*break*/, 6];
                        status = core$1.getVerStyleStrStatus(appName, platAndVer);
                        appStyleStr = '';
                        if (!(status === LOADING)) return [3 /*break*/, 2];
                        return [4 /*yield*/, inner.waitStyleReady(appName, __assign(__assign({}, platAndVer), { strictMatchVer: options.strictMatchVer }))];
                    case 1:
                        _d.sent();
                        appStyleStr = core$1.getAppStyleStr(appName, platAndVer) || '';
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(status === NOT_LOAD)) return [3 /*break*/, 4];
                        core$1.setVerStyleStrStatus(appName, LOADING, platAndVer);
                        return [4 /*yield*/, inner.fetchStyleStr(appCssList)];
                    case 3:
                        appStyleStr = _d.sent();
                        core$1.setAppStyleStr(appName, appStyleStr, platAndVer);
                        core$1.setVerStyleStrStatus(appName, LOADED, platAndVer);
                        eventBus$2.emit(STYLE_STR_FETCHED, __assign({ appName: appName }, platAndVer)); // 预设的样式列表转换为字符串完毕
                        return [3 /*break*/, 5];
                    case 4:
                        appStyleStr = core$1.getAppStyleStr(appName, platAndVer) || '';
                        _d.label = 5;
                    case 5:
                        result.renderStyleStr = "".concat(appStyleStr).concat(extraStyleStr);
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, inner.fetchStyleStr(validCssList)];
                    case 7:
                        styleStr = _d.sent();
                        result.renderStyleStr = "".concat(styleStr).concat(extraStyleStr);
                        _d.label = 8;
                    case 8: return [2 /*return*/, result];
                }
            });
        });
    },
};
/**
 * 返回渲染用的样式字符串传、及相关样式列表计算结果，具体描述见 IStyleDataResult
 * 调用者需自己确保版本数据已获取，即 preFetchApp 或 preFetchLib 已调用
 */
function fetchAppStyleData(appName, options) {
    return __awaiter(this, void 0, Promise, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inner.fetchStyleData(appName, options || {})];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
}
/**
 * 应用构建生成的 + 能追加的 staticLink、relativeLink + preFetch 时设置的 extraCssList 的全部样式列表之合集对应的字符串
 * 调用者需自己确保 appCssList 样式字符串已拉取，即  preFetchApp 或 preFetchLib 调用之后， fetchAppStyleData 已调用
 */
function getAppStyleStr(appName, options) {
    var platAndVer = getPlatAndVer(appName, options);
    var styleStr = core$1.getAppStyleStr(appName, platAndVer);
    return styleStr;
}
/**
 * 获取应用自身的样式列表，返回如下
 * buildCssList ：应用构建生成的样式列表
 * initExtraCssList ：preFetch 是设定的样式列表，该列表只接收一次设置，后续不再变动
 * appCssList ：应用构建生成的 + 能追加的 staticLink、relativeLink + preFetch 时设置的 extraCssList 的全部样式列表之合集
 */
function getAppCssList(appName, options) {
    var result = inner.getSelfCssList(appName, options || {});
    return result;
}
/**
 * 通过样式列表获取样式字符串
 * @param cssUrlList
 * @returns
 */
function fetchStyleByUrlList(cssUrlList) {
    return __awaiter(this, void 0, void 0, function () {
        var styleStr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, inner.fetchStyleStr(cssUrlList)];
                case 1:
                    styleStr = _a.sent();
                    return [2 /*return*/, styleStr];
            }
        });
    });
}
/**
 * 判断样式是否已经异步拉取过了
 */
function isStyleFetched(appName, options) {
    return inner.isStyleStatusMatch(appName, LOADED, options || {});
}
/**
 * 禁用所有 style tag 样式
 */
function disableStyleTags(groupName) {
    var g = core$1.getGlobalThis();
    if (g.document) {
        var styleTags = g.document.querySelectorAll("style[data-gname=\"".concat(groupName, "\"]"));
        styleTags.forEach(core$1.commonUtil.disableNode);
    }
}
function getStyleTagText(groupName) {
    var styleTagText = core$1.commonDataUtil.getStyleTagText(groupName);
    return styleTagText;
}
/**
 * 获取因主动设置了 ignoreCssPrefix 规则而忽略掉的样式列表
 */
function getIgnoredCssUrlList(name, options) {
    var cssPrefix = getSuitableCssPrefix(name, options);
    var cssList = core$1.commonDataUtil.getIgnoreCssPrefixCssUrlList(cssPrefix) || [];
    return cssList;
}
/**
 * 获取合适的 css 前缀
 */
function getSuitableCssPrefix(name, options) {
    var custom = ((options || {}).custom || {});
    var cssPrefix = '';
    var host = custom.host, _a = custom.enable, enable = _a === void 0 ? true : _a;
    if (host && enable) {
        if (host.endsWith('.json') || host.endsWith('.html')) {
            var arr = host.split('/');
            var len = arr.length;
            arr.splice(len - 1, len); // 去掉最后一位元素
            cssPrefix = arr.join('/');
        }
        else {
            cssPrefix = host;
        }
    }
    else {
        cssPrefix = getWebDirPath$1(name, options);
    }
    return cssPrefix;
}

var appStyle = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchAppStyleData: fetchAppStyleData,
  getAppStyleStr: getAppStyleStr,
  getAppCssList: getAppCssList,
  fetchStyleByUrlList: fetchStyleByUrlList,
  isStyleFetched: isStyleFetched,
  disableStyleTags: disableStyleTags,
  getStyleTagText: getStyleTagText,
  getIgnoredCssUrlList: getIgnoredCssUrlList,
  getSuitableCssPrefix: getSuitableCssPrefix
});

function tryFixAssociateData(appName, appGroupName, fixOptions) {
    var platform = fixOptions.platform;
    var oriMeta = getAppMeta(appGroupName, platform);
    if (oriMeta) {
        return;
    }
    // 因 appName 对应的 appMeta、version、extraCssList 数据由 micro 写入
    // trust 模式下是没有这些数据的，需补上 appGroupName 相关数据
    var custMeta = getAppMeta(appName, platform);
    var custVer = getVersion(appName, fixOptions);
    if (custMeta && custVer) {
        setAppMeta(__assign(__assign({}, custMeta), { name: appGroupName, __addedByTrust: true }), platform);
        setVersion(appGroupName, __assign(__assign({}, custVer), { sub_app_name: appGroupName, __addedByTrust: true }), { platform: platform });
        var cssList = getVerExtraCssList(appName, fixOptions);
        setVerExtraCssList(appGroupName, cssList, fixOptions);
    }
}
/**
 * @returns {boolean} - shouldNext
 */
function fixLibAssociateData(appName, appGroupName, fixOptions) {
    var platform = fixOptions.platform, emitPlatform = fixOptions.emitPlatform, versionId = fixOptions.versionId, emitVer = fixOptions.emitVer;
    var lib = getVerLib(appName, fixOptions);
    if (!lib) {
        tryFixAssociateData(appName, appGroupName, fixOptions);
        var originalLib = getVerLib(appGroupName, { platform: platform, versionId: versionId }); // appGroupName 对应 lib 由 core 写入，此处可获取到
        if (!originalLib && emitPlatform) {
            // 相信弹射的版本数据就是目标版本数据
            originalLib = getVerLib(appGroupName, { platform: emitPlatform, versionId: emitVer, strictMatchVer: false });
        }
        if (!originalLib) {
            throw new Error("seems plat ".concat(emitPlatform, " emit null lib for ").concat(appGroupName));
        }
        libReady(appGroupName, originalLib, { platform: platform, appName: appName, versionId: versionId }); // 强制转移给当前平台
        return false; // 不走 next()，等待 libReady 内部触发新的 judgeAppReady 流程
    }
    return true; // lib 匹配成功，执行 next()，返回给上层调用
}
/**
 * @returns {boolean} - shouldNext
 */
function fixAppAssociateData(appName, appGroupName, fixOptions) {
    var platform = fixOptions.platform, emitPlatform = fixOptions.emitPlatform, versionId = fixOptions.versionId, emitVer = fixOptions.emitVer;
    var emittedApp = getVerApp(appName, fixOptions);
    if (!emittedApp) {
        tryFixAssociateData(appName, appGroupName, fixOptions);
        var oriEmittedApp = getVerApp(appGroupName, { platform: platform, versionId: versionId });
        if (!oriEmittedApp && emitPlatform) {
            oriEmittedApp = getVerApp(appGroupName, { platform: emitPlatform, versionId: emitVer, strictMatchVer: false });
        }
        if (!oriEmittedApp) {
            throw new Error("seems plat ".concat(emitPlatform, " emit null app for ").concat(appGroupName));
        }
        emitApp$1(__assign(__assign({}, oriEmittedApp), { platform: platform, appGroupName: appGroupName, appName: appName, versionId: versionId })); // 强制转移给当前平台
        return false; // 不走 next()，等待 emitApp 内部触发新的 judgeAppReady 流程
    }
    return true; // app 匹配成功，执行 next()，返回给上层调用
}
function getLibOrApp(appName, innerOptions) {
    var _a = innerOptions.versionId, versionId = _a === void 0 ? '' : _a, isLib = innerOptions.isLib;
    var platform = getPlatform(innerOptions.platform);
    var strictMatchVer = getVal(platform, 'strictMatchVer', [innerOptions.strictMatchVer]);
    var newGetOptions = __assign(__assign({}, innerOptions), { strictMatchVer: strictMatchVer });
    var targetName = appName;
    var custom = innerOptions.custom;
    if (isCustomValid(custom)) {
        // 处于调试模式时，应用名可置换为用户人工设定的组名，以便让一个组名对应多个应用名的模式下，本地调试依然生效
        targetName = custom.appGroupName || appName;
    }
    var appMeta = getAppMeta(targetName, platform);
    // 语义化版本服务采用cdn架构存储元数据，它返回的 appMeta 里记录的 online_version 不可靠，这里要结合 __setByLatest 一起判断后才决定是否采用 lib
    if (innerOptions.semverApi && !versionId && appMeta && appMeta.__setByLatest !== true) {
        return null;
    }
    if (isLib) {
        var lib = getVerLib(targetName, newGetOptions);
        var libWrap = {
            appName: targetName,
            appGroupName: (appMeta === null || appMeta === void 0 ? void 0 : appMeta.app_group_name) || '',
            platform: platform,
            appProperties: lib,
            isLib: true,
            versionId: versionId,
            Comp: null,
            lifecycle: undefined,
        };
        return lib ? libWrap : null;
    }
    var emitApp = getVerApp(targetName, newGetOptions);
    return emitApp || null;
}
function judgeAppReady(appInfo, options, preFetchOptions) {
    var fnMark = '[[ judgeAppReady ]]';
    log("".concat(fnMark, " receive emitApp(appInfo):"), appInfo);
    var _a = options.versionId, inputVer = _a === void 0 ? '' : _a, projectId = options.projectId, appName = options.appName, platform = options.platform, next = options.next, error = options.error, isLib = options.isLib, strictMatchVer = options.strictMatchVer;
    var inputPlatform = getPlatform(platform);
    var emitAppName = appInfo.appName, appGroupName = appInfo.appGroupName, _b = appInfo.platform, emitPlatform = _b === void 0 ? inputPlatform : _b, emitVer = appInfo.versionId;
    var appPathDesc = "".concat(platform, "/").concat(appName, "/").concat(inputVer);
    var appMeta = getAppMeta(appName, platform);
    var custom = preFetchOptions.custom, trust = preFetchOptions.trust;
    var fixData = function (fixOptions) {
        try {
            var shouldNext = isLib
                ? fixLibAssociateData(appName, appGroupName, fixOptions)
                : fixAppAssociateData(appName, appGroupName, fixOptions);
            return shouldNext;
        }
        catch (err) {
            error(err);
            return false;
        }
    };
    if (custom) {
        var _c = custom.enable, enable = _c === void 0 ? true : _c, host = custom.host, customAppGroupName_1 = custom.appGroupName, _d = custom.trust, trust_1 = _d === void 0 ? false : _d;
        // 额外判断 appGroupName 是否存在，防止 appGroupName 是 undefined
        var isGroupNameValid = function () { return appGroupName && (appGroupName === appName || appGroupName === customAppGroupName_1); };
        if (enable && host) {
            // 非 trust 模式下，组名有效才识别为当前调用所需模块
            if (!trust_1) {
                isGroupNameValid() && next();
                return;
            }
            // trust 模式会强行复制远程模块为当前调用所需要模块，同时会为远程补齐缺失数据，开发者需要知道并承担其危险后果！
            var shouldNext = fixData({ versionId: inputVer, platform: inputPlatform, emitPlatform: emitPlatform, emitVer: emitVer });
            shouldNext && next();
            return;
        }
    }
    // 非严格版本匹配模式，只需要应用组名和平台值匹配即可，满足一些用户copy了资源到自己的项目目录下也想要正常加载的场景
    if (strictMatchVer === false && appGroupName && (appMeta === null || appMeta === void 0 ? void 0 : appMeta.app_group_name) === appGroupName && inputPlatform === emitPlatform) {
        log("".concat(fnMark, " treat emitApp as wanted when strictMatchVer is false (appInfo):"), appInfo);
        return next();
    }
    var logStillWait = function () { return log("".concat(fnMark, " still wait ").concat(appPathDesc, " emitted (appInfo,toMatch):"), appInfo, toMatch); };
    // 啥也不做，等待平台值匹配、应用名匹配的那个事件发射上来
    var toMatch = { platform: platform, emitVer: emitVer, inputVer: inputVer, projectId: projectId, strictMatchVer: strictMatchVer };
    if (appName !== emitAppName || !isEmitVerMatchInputVer(appName, toMatch)) {
        return logStillWait();
    }
    var trustAppNames = getVal(inputPlatform, 'trustAppNames', [null, []], { emptyArrIsNull: false });
    // sdk 初始化了一些信任的应用，或者模块使用方主动设置了信任模式，则开始走模块转移流程
    if (inputPlatform !== emitPlatform && (trust || trustAppNames.includes(appName))) {
        var shouldNext = fixData({ versionId: inputVer, platform: inputPlatform, emitPlatform: emitPlatform, emitVer: emitVer });
        if (!shouldNext) {
            log("".concat(fnMark, " transfer ").concat(emitPlatform, " app [").concat(appName, "] to ").concat(inputPlatform, " plat due to being in trustAppNames"));
            return logStillWait();
        }
    }
    next();
}

var logic = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getLibOrApp: getLibOrApp,
  judgeAppReady: judgeAppReady
});

/**
 * 3.3.2+，接口不再自动设置默认平台，非hel平台的模块，用户在获取或暴露模块时，
 * 需在 preFetchLib preFetchApp libReady exposeLib 接口里显式的传递平台值
 * @param initOptions
 */
function init$1(initOptions) {
    var platform = initOptions.platform, restOptions = __rest(initOptions, ["platform"]);
    core$1.initPlatformConfig(restOptions, platform);
}

/**
 * 此方法已不鼓励使用，请尽快替换为 hel-iso 包体里的 isSubApp
 * 因为当 hel-micro/hel-lib-proxy 提升到 webpack external 里时，此方法将返回错误结果
 * 此处保留是为了让老用户升级到最新版本时，如未使用 hel-micro/hel-lib-proxy external 模式依然能够编译通过并正常运行
 * @deprecated
 */
function isSubApp$1() {
    return core$1.isSubApp();
}

function injectDefault(externalItem) {
    if (externalItem && !externalItem.default) {
        try {
            // eslint-disable-next-line
            externalItem.default = externalItem;
            // prettier-ignore
        }
        catch (err) { }
    }
    return externalItem;
}
function bindExternals$1(externalsObj) {
    var globalThis = getGlobalThis();
    Object.keys(externalsObj).forEach(function (key) {
        var mod = externalsObj[key];
        if (mod) {
            // @ts-ignore
            globalThis[key] = mod;
        }
    });
}
/**
 * 存在以下几种情况时，可调用此接口让子模块顺利复用宿主 react 运行时（注：不存在以下情况调用此接口）
 * -------------------------------------------------
 * 1 宿主是 vite 开发环境，直接读取cdn react会照成 invalid hook call问题，见：https://github.com/vitejs/vite/issues/1584
 * 2 宿主没有配置 externals 外链 cdn react（ 例如在线IDE ）
 * 3 宿主配置的 externals 和子模块没有对齐
 * -------------------------------------------------
 * 不存在上诉情况调用此接口也没事，意味着可以总是调用此接口
 * @param reactRuntimeObj
 */
function bindReactRuntime$1(reactRuntimeObj) {
    var reactMod = injectDefault(reactRuntimeObj.React);
    var reactDomMod = injectDefault(reactRuntimeObj.ReactDOM);
    var reactIsMod = reactRuntimeObj.ReactIs || null;
    var reactReconcilerMod = reactRuntimeObj.ReactReconciler || null;
    var externalObj = {
        // 让一些采用了旧映射模式的包也能够正常加载
        LEAH_React: reactMod,
        LEAH_ReactDOM: reactDomMod,
        LEAH_ReactIs: reactIsMod,
        LEAH_ReactReconciler: reactReconcilerMod,
        // 对齐社区的挂载 key 名称
        React: reactMod,
        ReactDOM: reactDomMod,
        ReactIs: reactIsMod,
        ReactReconciler: reactReconcilerMod,
    };
    bindExternals$1(externalObj);
}
/**
 * 宿主调用此接口让子模块可复用宿主的 vue 运行时，详细意义同 bindReactRuntime 描述
 * @param vueRuntimeObj
 */
function bindVueRuntime$1(vueRuntimeObj) {
    var vueMod = injectDefault(vueRuntimeObj.Vue);
    var externalObj = {
        // 让一些采用了旧映射模式的包也能够正常加载
        LEAH_Vue: vueMod,
        // 对齐社区的挂载 key 名称
        Vue: vueMod,
    };
    bindExternals$1(externalObj);
}

function getExtraDataPrefix(appName) {
    return "".concat(toExport.EXTRA_DATA_PREFIX, ".").concat(appName);
}
function getExtraData$1(appName, shouldParse) {
    var _a, _b;
    var shouldParseVar = shouldParse !== null && shouldParse !== void 0 ? shouldParse : false;
    var str = (_b = (_a = getGlobalThis().localStorage) === null || _a === void 0 ? void 0 : _a.getItem(getExtraDataPrefix(appName))) !== null && _b !== void 0 ? _b : null;
    if (str) {
        if (shouldParseVar) {
            return JSON.parse(str);
        }
        return str;
    }
    return null;
}
function setExtraData$1(appName, data, shouldStringify) {
    var _a;
    var shouldStringifyVar = shouldStringify !== null && shouldStringify !== void 0 ? shouldStringify : false;
    var mayStr = shouldStringifyVar ? JSON.stringify(data) : data;
    (_a = getGlobalThis().localStorage) === null || _a === void 0 ? void 0 : _a.setItem(getExtraDataPrefix(appName), mayStr);
}

function getBodyContainer(idOrTriggerNode) {
    var _a;
    if (typeof idOrTriggerNode === 'string') {
        return (_a = getGlobalThis()) === null || _a === void 0 ? void 0 : _a.document.getElementById(idOrTriggerNode);
    }
    return idOrTriggerNode;
}
function getFakeHelContext$1(name, options) {
    return {
        name: name,
        platform: (options === null || options === void 0 ? void 0 : options.platform) || getAppPlatform(name),
        versionId: (options === null || options === void 0 ? void 0 : options.versionId) || '',
        getShadowAppRoot: getBodyContainer,
        getShadowBodyRoot: getBodyContainer,
    };
}

var getObjsVal = commonUtil$1.getObjsVal;
var ENABLE_DISK_CACHE = toExport.ENABLE_DISK_CACHE, ENABLE_SYNC_META = toExport.ENABLE_SYNC_META, STORAGE_TYPE = toExport.STORAGE_TYPE;
function makePreFetchOptions(isLib, options) {
    var optionsVar = typeof options === 'string' ? { versionId: options } : __assign({}, (options || {}));
    optionsVar.platform = getPlatform(optionsVar.platform);
    optionsVar.isLib = isLib;
    return optionsVar;
}
function markShadowDataBeforeLoad(appName, groupName, preFetchOptions) {
    if (preFetchOptions.shadow) {
        // 辅助后续流程标记 css link disable=true, style tag disable=true
        if (!groupName)
            return;
        var cssPrefix = getSuitableCssPrefix(appName, preFetchOptions);
        commonDataUtil.setIgnoreCssPrefix(cssPrefix);
        commonDataUtil.setIgnoreStyleTagKey(appName);
        commonDataUtil.setIgnoreStyleTagKey(groupName);
        commonDataUtil.setIgnoreCssPrefixKey(cssPrefix, groupName);
    }
}
function waitAppEmit(appName, innerOptions, loadAssetsStarter) {
    return __awaiter(this, void 0, void 0, function () {
        var eventBus, platform, _a, isLib, versionId, projectId, strictMatchVer, eventName, handleAppLoaded, emitAppOrLib;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    eventBus = getHelEventBus();
                    platform = innerOptions.platform, _a = innerOptions.isLib, isLib = _a === void 0 ? false : _a, versionId = innerOptions.versionId, projectId = innerOptions.projectId, strictMatchVer = innerOptions.strictMatchVer;
                    eventName = isLib ? helEvents.SUB_LIB_LOADED : helEvents.SUB_APP_LOADED;
                    handleAppLoaded = null;
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            handleAppLoaded = function (appInfo) {
                                judgeAppReady(appInfo, { appName: appName, platform: platform, versionId: versionId, projectId: projectId, isLib: isLib, next: resolve, error: reject, strictMatchVer: strictMatchVer }, innerOptions);
                            };
                            // 先监听，再触发资源加载，确保监听不会有遗漏
                            eventBus.on(eventName, handleAppLoaded);
                            if (loadAssetsStarter) {
                                var appMeta = getAppMeta(appName, platform);
                                appMeta && markShadowDataBeforeLoad(appName, appMeta.app_group_name, innerOptions);
                                loadAssetsStarter();
                            }
                        })];
                case 1:
                    _b.sent();
                    if (handleAppLoaded) {
                        eventBus.off(eventName, handleAppLoaded);
                    }
                    emitAppOrLib = getLibOrApp(appName, innerOptions);
                    return [2 /*return*/, emitAppOrLib];
            }
        });
    });
}
/**
 * 预抓取一些应用 js 脚本并解析执行，返回应用暴露的模块或组件
 * @param appName
 * @param preFetchOptions
 * @returns
 */
function innerPreFetch(appName, preFetchOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var emitApp, versionId, platform, isLib, strictMatchVer, semverApi, fixedInnerOptions, fnName, loadAssetsStarter, currentLoadStatus, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emitApp = null;
                    versionId = preFetchOptions.versionId, platform = preFetchOptions.platform, isLib = preFetchOptions.isLib, strictMatchVer = preFetchOptions.strictMatchVer, semverApi = preFetchOptions.semverApi;
                    fixedInnerOptions = __assign({}, preFetchOptions);
                    fnName = isLib ? 'preFetchLib' : 'preFetchApp';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    // 用户未传的话走平台默认值 true
                    fixedInnerOptions.strictMatchVer = getVal(platform, 'strictMatchVer', [strictMatchVer]);
                    // 默认为 indexedDB，不支持 indexedDB 的环境会降级为 localStorage
                    fixedInnerOptions.storageType = preFetchOptions.storageType || 'indexedDB';
                    fixedInnerOptions.semverApi = getVal(platform, 'semverApi', [semverApi]);
                    emitApp = getLibOrApp(appName, fixedInnerOptions);
                    if (emitApp) {
                        // 支持用户拉取同一个模块的多个版本，但是实际工程里不鼓励这么做
                        if (!versionId || (versionId && emitApp.versionId === versionId)) {
                            log("[[ ".concat(fnName, " ]] return cached app:"), appName, fixedInnerOptions);
                            return [2 /*return*/, { emitApp: emitApp, msg: '' }];
                        }
                    }
                    loadAssetsStarter = null;
                    currentLoadStatus = getVerLoadStatus(appName, fixedInnerOptions);
                    if (!(currentLoadStatus === helLoadStatus.LOADED)) return [3 /*break*/, 3];
                    return [4 /*yield*/, waitAppEmit(appName, fixedInnerOptions)];
                case 2:
                    emitApp = _a.sent();
                    log("[[ ".concat(fnName, " ]] return emit app:"), appName, fixedInnerOptions, emitApp);
                    return [2 /*return*/, { emitApp: emitApp, msg: '' }];
                case 3:
                    if (!(currentLoadStatus !== helLoadStatus.LOADING)) return [3 /*break*/, 5];
                    setVerLoadStatus(appName, helLoadStatus.LOADING, fixedInnerOptions);
                    return [4 /*yield*/, loadApp(appName, __assign(__assign({}, fixedInnerOptions), { controlLoadAssets: true }))];
                case 4:
                    loadAssetsStarter = _a.sent();
                    _a.label = 5;
                case 5: return [4 /*yield*/, waitAppEmit(appName, preFetchOptions, loadAssetsStarter)];
                case 6:
                    // 正在加载中，等待模块获取
                    emitApp = _a.sent();
                    log("[[ ".concat(fnName, " ]] return fetch&emit app:"), appName, fixedInnerOptions, emitApp);
                    return [2 /*return*/, { emitApp: emitApp, msg: '' }];
                case 7:
                    err_1 = _a.sent();
                    console.error(err_1);
                    // 标记未加载，下次再进入可以继续重试
                    setVerLoadStatus(appName, helLoadStatus.NOT_LOAD, fixedInnerOptions);
                    return [2 /*return*/, { emitApp: emitApp, msg: err_1.message }];
                case 8: return [2 /*return*/];
            }
        });
    });
}
/**
 * 等待 helEvents.SUB_LIB_LOADED 信号发射的模块对象
 * 由 hel-lib-proxy 的 libReady 函数发射上来
 * 这里采取相信用户传递的是正确的模块名原则，故返回类型不写为 Promise<T | null>，
 * 如用户需要有空值返回断言处理，可以写为
 * ```js
 *  const lib = await preFetchLib<Lib | null>('remote-lib-tpl');
 * ```
 */
function preFetchLib$1(appName, options) {
    return __awaiter(this, void 0, Promise, function () {
        var targetOpts, _a, emitApp, msg, appProperties, fallbackLib, details;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    targetOpts = makePreFetchOptions(true, options);
                    return [4 /*yield*/, innerPreFetch(appName, targetOpts)];
                case 1:
                    _a = _b.sent(), emitApp = _a.emitApp, msg = _a.msg;
                    appProperties = emitApp === null || emitApp === void 0 ? void 0 : emitApp.appProperties;
                    if (!appProperties && targetOpts.onLibNull) {
                        fallbackLib = targetOpts.onLibNull(appName, { versionId: targetOpts.versionId });
                        if (fallbackLib) {
                            appProperties = fallbackLib;
                        }
                    }
                    if (!appProperties) {
                        details = msg ? " details : ".concat(msg) : '';
                        throw new Error("preFetchLib ".concat(appName, " fail from ").concat(targetOpts.platform, ", it may be an invalid module!").concat(details));
                    }
                    return [2 /*return*/, appProperties];
            }
        });
    });
}
/**
 * 等待 helEvents.SUB_APP_LOADED 信号发射的应用根组件
 * 由中间层ui适配库自己实现，如 hel-micro-react 的 renderApp
 */
function preFetchApp$1(appName, options) {
    return __awaiter(this, void 0, void 0, function () {
        var targetOpts, appInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    targetOpts = makePreFetchOptions(false, options);
                    return [4 /*yield*/, innerPreFetch(appName, targetOpts)];
                case 1:
                    appInfo = _a.sent();
                    return [2 /*return*/, (appInfo === null || appInfo === void 0 ? void 0 : appInfo.emitApp) || null];
            }
        });
    });
}
/**
 * 批量预加载模块，特别注意一下两点：
 * 1 因服务器端控制，一次性最多只能获取 8 个
 * 2 该接口仅支持 hel-pack（包括其他私有部署版）
 */
function batchPreFetchLib$1(appNames, batchOptions) {
    return __awaiter(this, void 0, Promise, function () {
        var versionIdList, projectIdList, optionsMap, getOptions, platform, appDataList, shouldFetchAppNames, ensuredOptionsMap, _i, appNames_1, name, oriOptions, options, appData, tasks, mods;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    versionIdList = [];
                    projectIdList = [];
                    optionsMap = (batchOptions === null || batchOptions === void 0 ? void 0 : batchOptions.preFetchConfigs) || {};
                    getOptions = __assign({ semverApi: false }, ((batchOptions === null || batchOptions === void 0 ? void 0 : batchOptions.common) || {}));
                    platform = getPlatform(getOptions.platform);
                    if (appNames.length > 8) {
                        throw new Error('only support 8 appName at most!'); // 当前最多只支持最多拉8个
                    }
                    appDataList = [];
                    shouldFetchAppNames = [];
                    ensuredOptionsMap = {};
                    _i = 0, appNames_1 = appNames;
                    _a.label = 1;
                case 1:
                    if (!(_i < appNames_1.length)) return [3 /*break*/, 4];
                    name = appNames_1[_i];
                    oriOptions = optionsMap[name];
                    options = { platform: platform };
                    if (!oriOptions || typeof oriOptions === 'string') {
                        options.versionId = oriOptions || '';
                    }
                    else if (oriOptions) {
                        options = __assign(__assign({}, oriOptions), options);
                    }
                    ensuredOptionsMap[name] = options;
                    options.enableDiskCache = getObjsVal([options, getOptions], 'enableDiskCache', ENABLE_DISK_CACHE);
                    options.enableSyncMeta = getObjsVal([options, getOptions], 'enableSyncMeta', ENABLE_SYNC_META);
                    options.storageType = getObjsVal([options, getOptions], 'storageType', STORAGE_TYPE);
                    return [4 /*yield*/, getAppFromRemoteOrLocal(name, options, { callRemote: false })];
                case 2:
                    appData = _a.sent();
                    if (!appData) {
                        versionIdList.push(options.versionId || '');
                        projectIdList.push(options.projectId || '');
                        shouldFetchAppNames.push(name);
                    }
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    getOptions.versionIdList = versionIdList;
                    getOptions.projectIdList = projectIdList;
                    if (!getOptions.semverApi) return [3 /*break*/, 6];
                    return [4 /*yield*/, Promise.all(shouldFetchAppNames.map(function (name) { return getSubAppAndItsVersion(name, ensuredOptionsMap[name]); }))];
                case 5:
                    appDataList = _a.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, batchGetSubAppAndItsVersion(shouldFetchAppNames, getOptions)];
                case 7:
                    appDataList = _a.sent();
                    _a.label = 8;
                case 8:
                    // 设置到内存里，方便后续 preFetchLib 执行时可以跳过请求阶段
                    appDataList.forEach(function (_a) {
                        var app = _a.app, version = _a.version;
                        var loadOptions = ensuredOptionsMap[app.name] || {};
                        cacheApp(app, { appVersion: version, platform: platform, toDisk: loadOptions.enableDiskCache, loadOptions: loadOptions });
                    });
                    tasks = appNames.map(function (name) { return preFetchLib$1(name, ensuredOptionsMap[name]); });
                    return [4 /*yield*/, Promise.all(tasks)];
                case 9:
                    mods = _a.sent();
                    // @ts-ignore, trust user specified AnyRecord[]
                    return [2 /*return*/, mods];
            }
        });
    });
}

var apis = /*#__PURE__*/Object.freeze({
  __proto__: null,
  core: core$1,
  VER: VER$1,
  emitApp: emitApp$1,
  appMetaSrv: appMeta,
  appParamSrv: appParam,
  appStyleSrv: appStyle,
  logicSrv: logic,
  init: init$1,
  isSubApp: isSubApp$1,
  bindExternals: bindExternals$1,
  bindReactRuntime: bindReactRuntime$1,
  bindVueRuntime: bindVueRuntime$1,
  getExtraData: getExtraData$1,
  setExtraData: setExtraData$1,
  getFakeHelContext: getFakeHelContext$1,
  batchPreFetchLib: batchPreFetchLib$1,
  preFetchApp: preFetchApp$1,
  preFetchLib: preFetchLib$1
});

var purify = commonUtil$1.purify;
var eventBus$1 = core$1.getUserEventBus();
// 无需处理的 key
var ignoreKeys = ['eventBus', 'getExtraData', 'setExtraData', 'bindExternals', 'bindVueRuntime', 'bindReactRuntime', 'isSubApp'];
// core 层面函数处理规则
var coreRules = {
    // 不需要处理的
    ignoreFns: ['tryGetAppName', 'log', 'commonUtil', 'getCommonData', 'setCommonData', 'setGlobalThis'],
    // 这些函数仅1个参数，第1位参数是平台值
    arg1PlatFns: ['getPlatformConfig', 'getSharedCache'],
    // 这些函数共2个参数，第2位参数是平台值
    arg2PlatFns: ['initPlatformConfig', 'getAppMeta', 'setAppMeta', 'tryGetVersion', 'setAppPlatform'],
    // 这些函数共2个参数，第2位参数是平台值对象
    arg2PlatObjFns: [],
};
// 这些函数共2个参数，第2位参数是包含平台值的对象或版本号，且需要注入 semverApi 值
var preFetchFns = ['preFetchLib', 'preFetchApp'];
// 这些函数共2个参数，第2位参数需要注入 semverApi 值
var injectSemverApiFns = ['getSubAppMeta', 'getMetaDataUrl'];
// 这些函数第1位参数是平台值对象
var arg1PlatObjFns = ['emitApp', 'init'];
function injectPlat(platform, injectOptions) {
    var _this = this;
    var fnName = injectOptions.fnName, fn = injectOptions.fn, isCore = injectOptions.isCore, preFetchOptions = injectOptions.preFetchOptions;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var mergePlatObj = function (obj) { return (__assign({ platform: platform }, purify(obj || {}))); };
        var arg0 = args[0], arg1 = args[1], arg2 = args[2];
        if (isCore) {
            if (fnName === 'getPlatform') {
                // 来自 createInstace 实例调用，则返回的是对应的自定义平台
                return platform;
            }
            if (coreRules.arg1PlatFns.includes(fnName)) {
                args[0] = arg0 || platform;
            }
            else if (coreRules.arg2PlatFns.includes(fnName)) {
                args[1] = arg1 || platform;
            }
            else if (coreRules.arg2PlatObjFns.includes(fnName)) {
                args[1] = mergePlatObj(arg1);
            }
            else if (!coreRules.ignoreFns.includes(fnName)) {
                if (fnName.startsWith('set')) {
                    // 统一按第3位参数是包含平台值的对象来处理
                    args[2] = mergePlatObj(arg2);
                }
                else {
                    // 统一按第2位参数是包含平台值的对象来处理，对于 getGlobalThis 等内部仅使用第一位参数的函数，处理了也不影响
                    args[1] = mergePlatObj(arg1);
                }
            }
            // 剩下的 core 函数无需处理
        }
        else {
            // 开始处理非 core 层面的函数
            if (fnName === 'batchPreFetchLib') {
                // 特殊处理 batchPreFetchLib 的 batchOptions
                var arg1Var = arg1 || {};
                var common = mergePlatObj(arg1Var.common);
                args[1] = __assign(__assign({}, arg1Var), { common: common });
            }
            else if (preFetchFns.includes(fnName)) {
                var toMerge = purify(typeof arg1 === 'string' ? { versionId: arg1 } : arg1 || {});
                // 继续处理来自 createInstance 的预设参数
                if (preFetchOptions) {
                    toMerge = purify(__assign(__assign({}, preFetchOptions), toMerge));
                }
                args[1] = __assign({ platform: platform }, toMerge);
            }
            else if (injectSemverApiFns.includes(fnName)) {
                var _a = (preFetchOptions || {}).semverApi, semverApi = _a === void 0 ? true : _a;
                args[1] = mergePlatObj(__assign({ semverApi: semverApi }, purify(arg1 || {})));
            }
            else if (arg1PlatObjFns.includes(fnName)) {
                args[0] = mergePlatObj(arg0);
            }
            else {
                // 剩余的统一按第2位参数是包含平台值的对象来处理
                args[1] = mergePlatObj(arg1);
            }
        }
        // @ts-ignore
        return fn.apply(_this, args);
    };
}
function tryInectPlatForMethods(platform, obj, options) {
    var preFetchOptions = options.preFetchOptions, isCore = options.isCore;
    var newObj = {};
    Object.keys(obj).forEach(function (mayFnName) {
        // @ts-ignore
        var mayFn = obj[mayFnName];
        if (ignoreKeys.includes(mayFnName)) {
            newObj[mayFnName] = mayFn;
            return;
        }
        var valueType = typeof mayFn;
        if (valueType === 'function') {
            var injectOptions = { fnName: mayFnName, fn: mayFn, isCore: isCore, preFetchOptions: preFetchOptions };
            newObj[mayFnName] = injectPlat(platform, injectOptions);
            return;
        }
        if (mayFn && valueType === 'object') {
            var tryOptions = __assign(__assign({}, options), { isCore: mayFnName === 'core' });
            newObj[mayFnName] = tryInectPlatForMethods(platform, mayFn, tryOptions);
            return;
        }
        newObj[mayFnName] = mayFn;
    });
    return newObj;
}
/**
 * 预设获取参数自定义api实例，之后调用的api实例将总是自动带上用户的预设参数作为兜底参数
 * @param platform
 * @param preFetchOptions
 * @returns
 */
function createInstance$1(platform, preFetchOptions) {
    var insApis = tryInectPlatForMethods(platform, apis, { preFetchOptions: preFetchOptions });
    insApis.createInstance = createInstance$1;
    insApis.createOriginInstance = createOriginInstance$1;
    insApis.resetGlobalThis = core$1.resetGlobalThis;
    insApis.eventBus = eventBus$1;
    insApis.default = insApis;
    return insApis;
}
/**
 * 预设获取参数自定义api实例，同时将预设参数参数写入 origin 配置，这样用户使用原始 api 时也能够复用预设参数
 * ```
 * // 原始 api 指从 hel-micro 里直接导入的接口，例如下面的 preFetchLib 是原始 api
 * import { preFetchLib, createOriginInstance } from 'hel-micro';
 * // 预设 origin 配置
 * createOriginInstance('myplat', { apiPrefix: 'https://myplat.com', semverApi: false });
 * // 此后采用 preFetchLib 调用时将自动读取到对应平台预设的 origin 配置
 * preFetchLib('xx', {platform:'myplat'});
 * ```
 * 此方法通常用户用户基于 hel-micro 定制自己平台参数后再次发包到npm，别人使用此包体可自动获取对应平台的模块，例如
 * ```
 * // 发布此代码包体 custom-hel-micro 到 npm
 * import { preFetchLib, createOriginInstance } from 'hel-micro';
 * const ins = createOriginInstance(...);
 * export default ins;
 * ```
 */
function createOriginInstance$1(platform, originOptions) {
    var _a = originOptions || {}; _a.trustAppNames; var preFetchOptions = __rest(_a, ["trustAppNames"]);
    originInit(platform, originOptions);
    return createInstance$1(platform, preFetchOptions);
}

var VER = VER$1, preFetchLib = preFetchLib$1, preFetchApp = preFetchApp$1, batchPreFetchLib = batchPreFetchLib$1, appStyleSrv = appStyle, appParamSrv = appParam, appMetaSrv = appMeta, logicSrv = logic, emitApp = emitApp$1, init = init$1, isSubApp = isSubApp$1, getFakeHelContext = getFakeHelContext$1, getExtraData = getExtraData$1, setExtraData = setExtraData$1, bindExternals = bindExternals$1, bindVueRuntime = bindVueRuntime$1, bindReactRuntime = bindReactRuntime$1, core = core$1;
var resetGlobalThis = core$1.resetGlobalThis;
var createInstance = createInstance$1, createOriginInstance = createOriginInstance$1;
var eventBus = core$1.getUserEventBus();
core.log("hel-micro ver ".concat(VER));
var index = {
    VER: VER,
    preFetchLib: preFetchLib,
    preFetchApp: preFetchApp,
    batchPreFetchLib: batchPreFetchLib,
    appStyleSrv: appStyleSrv,
    appParamSrv: appParamSrv,
    appMetaSrv: appMetaSrv,
    logicSrv: logicSrv,
    emitApp: emitApp,
    eventBus: eventBus,
    init: init,
    isSubApp: isSubApp,
    getFakeHelContext: getFakeHelContext,
    getExtraData: getExtraData,
    setExtraData: setExtraData,
    bindExternals: bindExternals,
    bindVueRuntime: bindVueRuntime,
    bindReactRuntime: bindReactRuntime,
    resetGlobalThis: resetGlobalThis,
    core: core$1,
    createInstance: createInstance,
    createOriginInstance: createOriginInstance,
};

export { VER, appMetaSrv, appParamSrv, appStyleSrv, batchPreFetchLib, bindExternals, bindReactRuntime, bindVueRuntime, core, createInstance, createOriginInstance, index as default, emitApp, eventBus, getExtraData, getFakeHelContext, init, isSubApp, logicSrv, preFetchApp, preFetchLib, resetGlobalThis, setExtraData };
